import { ExpandLess, ExpandMore } from '@mui/icons-material';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import CloseIcon from '@mui/icons-material/Close';
import { Switch } from 'react-router-dom';
import _ from 'lodash';

import { FormButton } from '../../componets/form/formButton';
import MenuIcon from '@mui/icons-material/Menu';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import {
    Badge,
    Collapse,
    Drawer,
    Grid,
    ListItem,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    Modal,
    Stack,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Button,
    Tooltip,
    Popover,
    Checkbox,
} from '@mui/material';
import MuiAppBar, { AppBarProps as MuiAppBarProps } from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { styled, useTheme } from '@mui/material/styles';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import * as React from 'react';
import { Link, useHistory } from 'react-router-dom';
import AlertDialog from '../../componets/dialog/alertDialog';
import Footer from '../../componets/footer';
import { paths, rowsPerPageOptions } from '../../config';
import { useAuth } from '../../context/AuthContext';
import { useContextGlobal } from '../../context/ContextGlobal';
import { floatValue, formatNumber } from '../../util/infoFormat';
import './styles.scss';
import { useForm, UseFormSetValue } from 'react-hook-form';
import { useToast } from '../../context/ToastContext';
import api from '../../services/api';
import {
    handleExceptionMessage,
    handleExceptionMultipleMessages,
} from '../../util/handleExceptionAxios';
import { message } from '../../util/handleMessages';
import { FormInputNumber } from '../../componets/form/formInputNumber';
import {
    formatDateWithoutHours,
    momentDiff,
    momentZoneToDateAddDays,
    momentZoneToUnix,
} from '../../util/dateUtil';
import { IconComponent, icons } from '../../componets/icons';
import { objToQuery } from '../../util/query';
import { cpfAndCnpjMask } from '../../componets/form/mask/cpfAndCnpj';
import { ColumnDef, Row } from '@tanstack/react-table';
import { TableGeneric } from '../../componets/table';
import {
    GenericEnum,
    stateLegalProcessOptions,
} from '../../communs/enums/generic-enum';
import { setTypeUserInQuery } from '../../util/configTypeUser';
import IName from '../../util/interfaces/name';
import {
    IPropsList,
    ImperativeHandleAccessedByParentListComponent,
} from '../../componets/interfaces/listProps';
import * as ImplEnum from '../../communs/enums/generic-enum';
import {
    NEXT_AUDIENCE,
    NEXT_CUSTOMER_SERVICE,
    NEXT_EXPERTISE,
    NEXT_LEGAL_PROCESS,
    NEXT_TASK,
} from '../../util/operation';
import { type } from 'os';

const drawerWidth: number = 240;

interface AppBarProps extends MuiAppBarProps {
    open?: boolean;
}

interface Data {
    id: string;
    body: any;
    view: boolean;
    active?: boolean;
    company?: {
        id: string;
        description: string;
    };
}

interface INextExpertise {
    id: string;
    legalProcess: {
        id: string;
        customer: IName;
        processNumber: string;
    };
    phase: string;
    local: string;
    dateExpertise: Date;
    diffInDays: number;
    status: string;
    finished?: boolean;
}

interface INextLegalProcess {
    id: string;
    processNumber: string;
    customer: IName;
    phase: string;
    deadlineDate: Date;
    diffInDays: number;
    finished?: boolean;
}

interface INextAudience {
    id: string;
    legalProcess: {
        processNumber: string;
        customer: IName;
    };
    local: string;
    dateAudience: Date;
    diffInDays: number;
    status: string;
    finished?: boolean;
}

interface INextCustomerService {
    id: string;
    processNumber: string;
    customer: IName;
    dateNextContact: Date;
    diffInDays: number;
    finished?: boolean;
}

interface INextTask {
    id: string;
    customer: IName;
    urgency: string;
    taskDeadLine: Date;
    diffInDays: number;
    status: string;
    finished?: boolean;
}

type ApplyCheckboxEventType = {
    index: number;
    event: React.ChangeEvent<HTMLInputElement>;
    keyLocalStorage: string;
    rows: any[];
    setRows: (rows: any[]) => void;
};

interface AwardCustomer {
    id: string;
    name: string;
    awardGiven: number;
    total: number;
    awardActual: number;
}

interface IInvoiceDetail {
    formPayment: string;
    typePayment: string;
    description: string;
    dueDate: Date;
    installmentValue: number;
    downloaded: boolean;
    workOrder?: {
        id: string;
        code: string;
        customer: {
            id: string;
            name: string;
            identification: string;
        };
    };
    outputProduct?: {
        id: string;
        code: string;
        customer: {
            id: string;
            name: string;
            identification: string;
        };
    };
}

interface IFinished {
    finished: boolean;
    id: string;
}

interface IListFinished {
    finished: IFinished[];
}

interface DataBirthdayCustomer {
    id: string;
    name: string;
    birthDate: string;
    yearsOld: number;
}

interface HeadCellAward {
    disablePadding: boolean;
    id: keyof AwardCustomer;
    label: string;
    numeric: boolean;
}

interface ModalProps {
    open: boolean;
    setOpen: (open: boolean) => void;
    rows: Data[];
    width: number;
    setRows: (data: Data[]) => void;
}

interface IRowBase {
    id: number | string;
    view?: boolean;
}
interface IModalProps<T extends IRowBase> {
    open: boolean;
    setOpen: (open: boolean) => void;
    rows: T[];
    setRows: (data: T[]) => void;
    keyLocalStorage: string;
    apiPath: string;
    route: string;
    columns: ColumnDef<any>[];
    title: string;
    width: number;
    icon: React.ReactNode;
    quantity: number;
    setValue?: (key: string, value: any) => void;
}

interface ImperativeHandleAccessedByMainContainerComponent {
    addStyleNotView: (row: any) => any;
    handleClick: (value: any, row: any) => void;
    setOpenModalInactiveNotification: (open: boolean) => void;
    setIdInactiveNotification: (id: string) => void;
    changeToView: (row: any) => void;
}

interface ModalAwardProps {
    open: boolean;
    setOpen: (open: boolean) => void;
    rows: AwardCustomer[];
    setListAwardedCustomers: (list: AwardCustomer[]) => void;
    width: number;
}
interface ModalOverdueInstallmentProps {
    open: boolean;
    setOpen: (open: boolean) => void;
    rows: IInvoiceDetail[];
    width: number;
}

interface ModalBirthdayCustomerProps {
    open: boolean;
    setOpen: (open: boolean) => void;
    rows: Data[];
    width: number;
    setRows: (data: Data[]) => void;
}

interface ModalApplyAwardProps {
    open: boolean;
    setOpen: (open: boolean) => void;
    data?: AwardCustomer;
    setListAwardedCustomers: (list: AwardCustomer[]) => void;
    width: number;
}

const headCellsAward: readonly HeadCellAward[] = [
    {
        id: 'name',
        numeric: false,
        disablePadding: false,
        label: 'Cliente',
    },
    {
        id: 'total',
        numeric: false,
        disablePadding: false,
        label: 'Total acumulado',
    },
    {
        id: 'awardGiven',
        numeric: false,
        disablePadding: false,
        label: 'Acumulado de premiações',
    },
    {
        id: 'awardActual',
        numeric: false,
        disablePadding: false,
        label: 'Valor atingido',
    },
];

type Props = { children: React.ReactNode };

interface IChildrenItem {
    icon: React.ReactNode;
    sx?: any;
    to: string;
    name: string;
    dataQa: string;
}
interface IListItem {
    icon: React.ReactNode;
    onClick?: () => void;
    name: string;
    open?: boolean;
    dataQa: string;
    to?: string;
    sx?: any;
    childrens: IChildrenItem[];
}
interface IPropsListItem {
    items: IListItem[];
}

const styleListIcon = { minWidth: 0, pr: 1 };

const RenderList = (props: IPropsListItem) => {
    const { items } = props;

    return (
        <List component="nav">
            {items.map((item: IListItem, indexItem: number) => {
                if (item.childrens.length > 0) {
                    return (
                        <React.Fragment key={indexItem}>
                            <ListItem
                                sx={item?.sx || {}}
                                data-qa={item.dataQa}
                                button
                                onClick={() => {
                                    if (item?.onClick) {
                                        item.onClick();
                                    }
                                }}>
                                <ListItemIcon sx={styleListIcon}>
                                    {item.icon}
                                </ListItemIcon>
                                <ListItemText primary={item.name} />
                                {item?.open ? <ExpandLess /> : <ExpandMore />}
                            </ListItem>
                            <Collapse
                                in={item?.open}
                                timeout="auto"
                                unmountOnExit>
                                {item.childrens.map(children => {
                                    return (
                                        <ListItem
                                            data-qa={children.dataQa}
                                            button
                                            sx={children?.sx || {}}
                                            component={Link}
                                            to={children.to}>
                                            <ListItemButton>
                                                <ListItemIcon
                                                    sx={styleListIcon}>
                                                    {children.icon}
                                                </ListItemIcon>
                                                <ListItemText
                                                    primary={children.name}
                                                />
                                            </ListItemButton>
                                        </ListItem>
                                    );
                                })}
                            </Collapse>
                        </React.Fragment>
                    );
                }
                return (
                    <ListItemButton
                        sx={item?.sx || {}}
                        data-qa={item.dataQa}
                        component={Link}
                        onClick={() => {
                            if (item?.onClick) {
                                item.onClick();
                            }
                        }}
                        to={item?.to || ''}>
                        <ListItemIcon sx={styleListIcon}>
                            {item.icon}
                        </ListItemIcon>
                        <ListItemText primary={item.name} />
                    </ListItemButton>
                );
            })}
        </List>
    );
};

const Main = styled('main', { shouldForwardProp: prop => prop !== 'open' })<{
    open?: boolean;
}>(({ theme, open }) => ({
    flexGrow: 1,
    padding: theme.spacing(3),
    transition: theme.transitions.create('margin', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    marginLeft: `-${open ? drawerWidth : 0}px`,
    ...(open && {
        transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen,
        }),
        marginLeft: 0,
    }),
}));

const AppBar = styled(MuiAppBar, {
    shouldForwardProp: prop => prop !== 'open',
})<AppBarProps>(({ theme, open }) => ({
    transition: theme.transitions.create(['margin', 'width'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    ...(open && {
        width: `calc(100% - ${open ? drawerWidth : 0}px)`,
        marginLeft: `${open ? drawerWidth : 0}px`,
        transition: theme.transitions.create(['margin', 'width'], {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen,
        }),
    }),
}));

const DrawerHeader = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
    justifyContent: 'flex-end',
}));

// const socket = io('http://localhost:6002');

const titleMessages = {
    nextAudience: 'Próximas audiências',
    birthDays: 'Aniversariante(s)',
};

const notApplyDisplayNone = (condition: boolean) => {
    if (!condition) {
        return { display: 'none' };
    }
    return {};
};

const instanceStateOptions = new GenericEnum(stateLegalProcessOptions);

const MainContainer: React.FC<Props> = ({ children }) => {
    const history = useHistory();
    const theme = useTheme();
    const [width] = useWindowSize();

    // const refForm = React.useRef<
    //     ImperativeHandleAccessedByMainContainerComponent[] | null
    // >([]);

    const refForm = React.useRef<
        Array<ImperativeHandleAccessedByMainContainerComponent | null>
    >([]);

    const [openModalNextAudience, setOpenModalNextAudience] =
        React.useState(false);
    const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(
        null,
    );

    const [openModalBirthday, setOpenModalBirthday] = React.useState(false);
    const [listAwardedCustomers, setListAwardedCustomers] = React.useState<
        AwardCustomer[]
    >([]);
    const [openModalAwardedCustomers, setOpenModalAwardedCustomers] =
        React.useState(false);
    const [listOverdueInstallments, setListOverdueInstallments] =
        React.useState<IInvoiceDetail[]>([]);
    const [openModalOverdueInstallments, setOpenModalOverdueInstallments] =
        React.useState(false);

    const {
        openCollapseRecords,
        handleOpenCollapseRecords,
        openCollapseInvoicing,
        handleOpenCollapseInvoicing,
        openCollapsePermissions,
        handleOpenCollapsePermissions,
        openCollapseExpenditurePortions,
        listBirthdays,
        setListBirthdays,
        notificationNextExpertise,
        setNotificationNextExpertise,
        listNotificationNextExpertise,
        setListNotificationNextExpertise,
        notificationNextLegalProcess,
        setNotificationNextLegalProcess,
        listNotificationNextLegalProcess,
        setListNotificationNextLegalProcess,
        notificationNextAudience,
        setNotificationNextAudience,
        setListNotificationNextAudience,
        listNotificationNextAudience,
        notificationNextCustomerService,
        setNotificationNextCustomerService,
        setListNotificationNextCustomerService,
        listNotificationNextCustomerService,
        notificationNextTask,
        setNotificationNextTask,
        setListNotificationNextTask,
        listNotificationNextTask,
    } = useContextGlobal();

    const applyCheckboxEvent = ({
        index,
        event,
        keyLocalStorage,
        rows,
        setRows,
    }: ApplyCheckboxEventType) => {
        let data = [...rows];
        data[index].finished = event.target.checked;

        data.forEach((d: any) => {
            d.token = localStorage.getItem('@GESSIS:token');
        });
        localStorage.setItem(keyLocalStorage, JSON.stringify(data));

        setRows(data);
    };

    const columnsTableNextExpertise = React.useCallback(
        (idx: number): ColumnDef<INextExpertise>[] => {
            return [
                {
                    accessorKey: 'finished',
                    cell: ({ row }: { row: Row<INextExpertise> }) => {
                        let index = row.index;

                        return (
                            <TableCell align="left">
                                <Checkbox
                                    name={`checkbox.${index}`}
                                    checked={row.original.finished}
                                    onChange={event => {
                                        applyCheckboxEvent({
                                            index,
                                            event,
                                            keyLocalStorage: NEXT_EXPERTISE,
                                            rows: listNotificationNextExpertise,
                                            setRows:
                                                setListNotificationNextExpertise,
                                        });
                                    }}
                                />
                            </TableCell>
                        );
                    },
                    header: () => (
                        <TableCell align={'left'} padding={'normal'}>
                            Encerrar prazo/pendência
                        </TableCell>
                    ),
                },
                {
                    id: 'select',
                    header: () => (
                        <TableCell align={'left'} padding={'normal'}>
                            Número do processo
                        </TableCell>
                    ),
                    cell: ({ row }: { row: Row<INextExpertise> }) => {
                        return (
                            <TableCell
                                sx={refForm?.current[idx]?.addStyleNotView(row)}
                                align="left"
                                key={row.id}
                                onMouseOver={(e: any) =>
                                    refForm?.current[idx]?.changeToView(row)
                                }
                                onClick={() =>
                                    refForm?.current[idx]?.handleClick(
                                        row.original.id,
                                        row,
                                    )
                                }>
                                {row.original?.legalProcess?.processNumber}
                            </TableCell>
                        );
                    },
                },
                {
                    id: 'legalProcess.customer.name',
                    header: () => (
                        <TableCell align={'left'} padding={'normal'}>
                            Cliente
                        </TableCell>
                    ),
                    cell: ({ row }: { row: Row<INextExpertise> }) => {
                        return (
                            <TableCell
                                sx={refForm?.current[idx]?.addStyleNotView(row)}
                                align="left"
                                key={row.id}
                                onMouseOver={(e: any) =>
                                    refForm?.current[idx]?.changeToView(row)
                                }
                                onClick={() =>
                                    refForm?.current[idx]?.handleClick(
                                        row.original.id,
                                        row,
                                    )
                                }>
                                {row.original?.legalProcess?.customer?.name}
                            </TableCell>
                        );
                    },
                },
                {
                    id: 'local',
                    header: () => (
                        <TableCell align={'left'} padding={'normal'}>
                            Local
                        </TableCell>
                    ),
                    cell: ({ row }: { row: Row<INextExpertise> }) => {
                        return (
                            <TableCell
                                sx={refForm?.current[idx]?.addStyleNotView(row)}
                                align="left"
                                key={row.id}
                                onMouseOver={(e: any) =>
                                    refForm?.current[idx]?.changeToView(row)
                                }
                                onClick={() =>
                                    refForm?.current[idx]?.handleClick(
                                        row.original.id,
                                        row,
                                    )
                                }>
                                {row.original.local}
                            </TableCell>
                        );
                    },
                },
                {
                    accessorKey: 'dateExpertise',
                    cell: ({ row }: { row: Row<INextExpertise> }) => (
                        <TableCell
                            sx={refForm?.current[idx]?.addStyleNotView(row)}
                            align="left"
                            onMouseOver={(e: any) =>
                                refForm?.current[idx]?.changeToView(row)
                            }
                            onClick={() =>
                                refForm?.current[idx]?.handleClick(
                                    row.original.id,
                                    row,
                                )
                            }>
                            {row.original?.dateExpertise &&
                                formatDateWithoutHours(
                                    row.original.dateExpertise,
                                )}
                        </TableCell>
                    ),
                    header: () => (
                        <TableCell align={'left'} padding={'normal'}>
                            Prazo
                        </TableCell>
                    ),
                },
                {
                    accessorKey: 'diffInDays',
                    cell: ({ row }: { row: Row<INextExpertise> }) => (
                        <TableCell
                            sx={refForm?.current[idx]?.addStyleNotView(row)}
                            align="left"
                            onMouseOver={(e: any) =>
                                refForm?.current[idx]?.changeToView(row)
                            }
                            onClick={() =>
                                refForm?.current[idx]?.handleClick(
                                    row.original.id,
                                    row,
                                )
                            }>
                            {_.isNumber(row.original?.diffInDays) &&
                                row.original.diffInDays}
                        </TableCell>
                    ),
                    header: () => (
                        <TableCell align={'left'} padding={'normal'}>
                            Dias faltantes
                        </TableCell>
                    ),
                },
                {
                    accessorKey: 'status',
                    cell: ({ row }: { row: Row<INextExpertise> }) => (
                        <TableCell
                            sx={refForm?.current[idx]?.addStyleNotView(row)}
                            align="left"
                            onMouseOver={(e: any) =>
                                refForm?.current[idx]?.changeToView(row)
                            }
                            onClick={() =>
                                refForm?.current[idx]?.handleClick(
                                    row.original.id,
                                    row,
                                )
                            }>
                            {row.original?.status &&
                                enumInstances.expertiseSituationOptionsInstance.getObject(
                                    row.original.status,
                                )?.description}
                        </TableCell>
                    ),
                    header: () => (
                        <TableCell align={'left'} padding={'normal'}>
                            Status
                        </TableCell>
                    ),
                },
                {
                    id: 'select',
                    header: ({ table }: any) => <TableCell align="center" />,
                    cell: ({ row }: any) => (
                        <TableCell align="right">
                            <Tooltip title={'Encerrar prazo/pendência'}>
                                <IconButton
                                    onClick={() => {
                                        refForm?.current[
                                            idx
                                        ]?.setIdInactiveNotification(
                                            row.original.id,
                                        );
                                        refForm?.current[
                                            idx
                                        ]?.setOpenModalInactiveNotification(
                                            true,
                                        );
                                    }}>
                                    <IconComponent icon={icons.ToggleOn} />
                                </IconButton>
                            </Tooltip>
                        </TableCell>
                    ),
                },
            ];
        },
        [listNotificationNextExpertise, setListNotificationNextExpertise],
    );

    const columnsTableNextLegalProcess = React.useCallback(
        (idx: number): ColumnDef<INextLegalProcess>[] => {
            return [
                {
                    accessorKey: 'finished',
                    cell: ({ row }: { row: Row<INextLegalProcess> }) => {
                        let index = row.index;

                        return (
                            <TableCell align="left">
                                <Checkbox
                                    name={`checkbox.${index}`}
                                    checked={row.original.finished}
                                    onChange={event => {
                                        applyCheckboxEvent({
                                            index,
                                            event,
                                            keyLocalStorage: NEXT_LEGAL_PROCESS,
                                            rows: listNotificationNextLegalProcess,
                                            setRows:
                                                setListNotificationNextLegalProcess,
                                        });
                                    }}
                                />
                            </TableCell>
                        );
                    },
                    header: () => (
                        <TableCell align={'left'} padding={'normal'}>
                            Encerrar prazo/pendência
                        </TableCell>
                    ),
                },
                {
                    id: 'select',
                    header: () => (
                        <TableCell align={'left'} padding={'normal'}>
                            Número do processo
                        </TableCell>
                    ),
                    cell: ({ row }: { row: Row<INextLegalProcess> }) => {
                        return (
                            <TableCell
                                sx={refForm.current[idx]?.addStyleNotView(row)}
                                align="left"
                                key={row.id}
                                onMouseOver={(e: any) =>
                                    refForm?.current[idx]?.changeToView(row)
                                }
                                onClick={() =>
                                    refForm?.current[idx]?.handleClick(
                                        row.original.id,
                                        row,
                                    )
                                }>
                                {row.original?.processNumber}
                            </TableCell>
                        );
                    },
                },
                {
                    id: 'legalProcess.customer.name',
                    header: () => (
                        <TableCell align={'left'} padding={'normal'}>
                            Cliente
                        </TableCell>
                    ),
                    cell: ({ row }: { row: Row<INextLegalProcess> }) => {
                        return (
                            <TableCell
                                sx={refForm?.current[idx]?.addStyleNotView(row)}
                                align="left"
                                key={row.id}
                                onMouseOver={(e: any) =>
                                    refForm?.current[idx]?.changeToView(row)
                                }
                                onClick={() =>
                                    refForm?.current[idx]?.handleClick(
                                        row.original.id,
                                        row,
                                    )
                                }>
                                {row.original?.customer?.name}
                            </TableCell>
                        );
                    },
                },
                {
                    id: 'phase',
                    header: () => (
                        <TableCell align={'left'} padding={'normal'}>
                            Fase
                        </TableCell>
                    ),
                    cell: ({ row }: { row: Row<INextLegalProcess> }) => {
                        return (
                            <TableCell
                                sx={refForm?.current[idx]?.addStyleNotView(row)}
                                align="left"
                                key={row.id}
                                onMouseOver={(e: any) =>
                                    refForm?.current[idx]?.changeToView(row)
                                }
                                onClick={() =>
                                    refForm?.current[idx]?.handleClick(
                                        row.original.id,
                                        row,
                                    )
                                }>
                                {row.original?.phase &&
                                    enumInstances.phaseLegalProcessOptionsInstance.getObject(
                                        row.original.phase,
                                    )?.description}
                            </TableCell>
                        );
                    },
                },
                {
                    accessorKey: 'dateExpertise',
                    cell: ({ row }: { row: Row<INextLegalProcess> }) => (
                        <TableCell
                            sx={refForm?.current[idx]?.addStyleNotView(row)}
                            align="left"
                            onMouseOver={(e: any) =>
                                refForm?.current[idx]?.changeToView(row)
                            }
                            onClick={() =>
                                refForm?.current[idx]?.handleClick(
                                    row.original.id,
                                    row,
                                )
                            }>
                            {row.original?.deadlineDate &&
                                formatDateWithoutHours(
                                    row.original.deadlineDate,
                                )}
                        </TableCell>
                    ),
                    header: () => (
                        <TableCell align={'left'} padding={'normal'}>
                            Prazo
                        </TableCell>
                    ),
                },
                {
                    accessorKey: 'diffInDays',
                    cell: ({ row }: { row: Row<INextLegalProcess> }) => (
                        <TableCell
                            sx={refForm?.current[idx]?.addStyleNotView(row)}
                            align="left"
                            onMouseOver={(e: any) =>
                                refForm?.current[idx]?.changeToView(row)
                            }
                            onClick={() =>
                                refForm?.current[idx]?.handleClick(
                                    row.original.id,
                                    row,
                                )
                            }>
                            {_.isNumber(row.original?.diffInDays) &&
                                row.original.diffInDays}
                        </TableCell>
                    ),
                    header: () => (
                        <TableCell align={'left'} padding={'normal'}>
                            Dias faltantes
                        </TableCell>
                    ),
                },
                {
                    id: 'select',
                    header: ({ table }: any) => <TableCell align="center" />,
                    cell: ({ row }: any) => (
                        <TableCell align="right">
                            <Tooltip title={'Encerrar prazo/pendência'}>
                                <IconButton
                                    onClick={() => {
                                        refForm?.current[
                                            idx
                                        ]?.setIdInactiveNotification(
                                            row.original.id,
                                        );
                                        refForm?.current[
                                            idx
                                        ]?.setOpenModalInactiveNotification(
                                            true,
                                        );
                                    }}>
                                    <IconComponent icon={icons.ToggleOn} />
                                </IconButton>
                            </Tooltip>
                        </TableCell>
                    ),
                },
            ];
        },
        [listNotificationNextLegalProcess, setListNotificationNextLegalProcess],
    );

    const columnsTableNextAudience = React.useCallback(
        (idx: number): ColumnDef<INextAudience>[] => {
            return [
                {
                    accessorKey: 'finished',
                    cell: ({ row }: { row: Row<INextAudience> }) => {
                        let index = row.index;

                        return (
                            <TableCell align="left">
                                <Checkbox
                                    name={`checkbox.${index}`}
                                    checked={row.original.finished}
                                    onChange={event => {
                                        applyCheckboxEvent({
                                            index,
                                            event,
                                            keyLocalStorage: NEXT_AUDIENCE,
                                            rows: listNotificationNextAudience,
                                            setRows:
                                                setListNotificationNextAudience,
                                        });
                                    }}
                                />
                            </TableCell>
                        );
                    },
                    header: () => (
                        <TableCell align={'left'} padding={'normal'}>
                            Encerrar prazo/pendência
                        </TableCell>
                    ),
                },
                {
                    id: 'processNumber',
                    header: () => (
                        <TableCell align={'left'} padding={'normal'}>
                            Número do processo
                        </TableCell>
                    ),
                    cell: ({ row }: { row: Row<INextAudience> }) => {
                        return (
                            <TableCell
                                sx={refForm?.current[idx]?.addStyleNotView(row)}
                                align="left"
                                key={row.id}
                                onMouseOver={(e: any) =>
                                    refForm?.current[idx]?.changeToView(row)
                                }
                                onClick={() =>
                                    refForm?.current[idx]?.handleClick(
                                        row.original.id,
                                        configPaths['audience'],
                                    )
                                }>
                                {row.original?.legalProcess?.processNumber}
                            </TableCell>
                        );
                    },
                },
                {
                    id: 'customer.name',
                    header: () => (
                        <TableCell align={'left'} padding={'normal'}>
                            Cliente
                        </TableCell>
                    ),
                    cell: ({ row }: { row: Row<INextAudience> }) => {
                        return (
                            <TableCell
                                sx={refForm?.current[idx]?.addStyleNotView(row)}
                                align="left"
                                key={row.id}
                                onMouseOver={(e: any) =>
                                    refForm?.current[idx]?.changeToView(row)
                                }
                                onClick={() =>
                                    refForm?.current[idx]?.handleClick(
                                        row.original.id,
                                        configPaths['audience'],
                                    )
                                }>
                                {row.original?.legalProcess?.customer?.name}
                            </TableCell>
                        );
                    },
                },
                {
                    id: 'local',
                    header: () => (
                        <TableCell align={'left'} padding={'normal'}>
                            Local
                        </TableCell>
                    ),
                    cell: ({ row }: { row: Row<INextAudience> }) => {
                        return (
                            <TableCell
                                sx={refForm?.current[idx]?.addStyleNotView(row)}
                                align="left"
                                key={row.id}
                                onMouseOver={(e: any) =>
                                    refForm?.current[idx]?.changeToView(row)
                                }
                                onClick={() =>
                                    refForm?.current[idx]?.handleClick(
                                        row.original.id,
                                        configPaths['audience'],
                                    )
                                }>
                                {row.original.local}
                            </TableCell>
                        );
                    },
                },
                {
                    accessorKey: 'dateAudience',
                    cell: ({ row }: { row: Row<INextAudience> }) => (
                        <TableCell
                            sx={refForm?.current[idx]?.addStyleNotView(row)}
                            align="left"
                            onMouseOver={(e: any) =>
                                refForm?.current[idx]?.changeToView(row)
                            }
                            onClick={() =>
                                refForm?.current[idx]?.handleClick(
                                    row.original.id,
                                    configPaths['audience'],
                                )
                            }>
                            {row.original?.dateAudience &&
                                formatDateWithoutHours(
                                    row.original.dateAudience,
                                )}
                        </TableCell>
                    ),
                    header: () => (
                        <TableCell align={'left'} padding={'normal'}>
                            Data
                        </TableCell>
                    ),
                },
                {
                    accessorKey: 'diffInDays',
                    cell: ({ row }: { row: Row<INextAudience> }) => (
                        <TableCell
                            sx={refForm?.current[idx]?.addStyleNotView(row)}
                            align="left"
                            onMouseOver={(e: any) =>
                                refForm?.current[idx]?.changeToView(row)
                            }
                            onClick={() =>
                                refForm?.current[idx]?.handleClick(
                                    row.original.id,
                                    configPaths['audience'],
                                )
                            }>
                            {_.isNumber(row.original?.diffInDays) &&
                                row.original.diffInDays}
                        </TableCell>
                    ),
                    header: () => (
                        <TableCell align={'left'} padding={'normal'}>
                            Status
                        </TableCell>
                    ),
                },
                {
                    accessorKey: 'status',
                    cell: ({ row }: { row: Row<INextAudience> }) => (
                        <TableCell
                            sx={refForm?.current[idx]?.addStyleNotView(row)}
                            align="left"
                            onMouseOver={(e: any) =>
                                refForm?.current[idx]?.changeToView(row)
                            }
                            onClick={() =>
                                refForm?.current[idx]?.handleClick(
                                    row.original.id,
                                    configPaths['audience'],
                                )
                            }>
                            {row.original?.status &&
                                enumInstances.expertiseSituationOptionsInstance.getObject(
                                    row.original.status,
                                )?.description}
                        </TableCell>
                    ),
                    header: () => (
                        <TableCell align={'left'} padding={'normal'}>
                            Dias faltantes
                        </TableCell>
                    ),
                },
                {
                    id: 'select',
                    header: ({ table }: any) => <TableCell align="center" />,
                    cell: ({ row }: any) => (
                        <TableCell align="right">
                            <Tooltip title={'Encerrar prazo/pendência'}>
                                <IconButton
                                    onClick={() => {
                                        refForm?.current[
                                            idx
                                        ]?.setIdInactiveNotification(
                                            row.original.id,
                                        );
                                        refForm?.current[
                                            idx
                                        ]?.setOpenModalInactiveNotification(
                                            true,
                                        );
                                    }}>
                                    <IconComponent icon={icons.ToggleOn} />
                                </IconButton>
                            </Tooltip>
                        </TableCell>
                    ),
                },
            ];
        },
        [listNotificationNextAudience, setListNotificationNextAudience],
    );

    const columnsTableNextCustomerService = React.useCallback(
        (idx: number): ColumnDef<INextCustomerService>[] => {
            return [
                {
                    accessorKey: 'finished',
                    cell: ({ row }: { row: Row<INextCustomerService> }) => {
                        let index = row.index;

                        return (
                            <TableCell align="left">
                                <Checkbox
                                    name={`checkbox.${index}`}
                                    checked={row.original.finished}
                                    onChange={event => {
                                        applyCheckboxEvent({
                                            index,
                                            event,
                                            keyLocalStorage:
                                                NEXT_CUSTOMER_SERVICE,
                                            rows: listNotificationNextCustomerService,
                                            setRows:
                                                setListNotificationNextCustomerService,
                                        });
                                    }}
                                />
                            </TableCell>
                        );
                    },
                    header: () => (
                        <TableCell align={'left'} padding={'normal'}>
                            Encerrar prazo/pendência
                        </TableCell>
                    ),
                },
                {
                    id: 'customer.name',
                    header: () => (
                        <TableCell align={'left'} padding={'normal'}>
                            Cliente
                        </TableCell>
                    ),
                    cell: ({ row }: { row: Row<INextCustomerService> }) => {
                        return (
                            <TableCell
                                sx={refForm?.current[idx]?.addStyleNotView(row)}
                                align="left"
                                key={row.id}
                                onMouseOver={(e: any) =>
                                    refForm?.current[idx]?.changeToView(row)
                                }
                                onClick={() =>
                                    refForm?.current[idx]?.handleClick(
                                        row.original.id,
                                        configPaths['customerService'],
                                    )
                                }>
                                {row.original?.customer?.name}
                            </TableCell>
                        );
                    },
                },
                {
                    accessorKey: 'dateCustomerService',
                    cell: ({ row }: { row: Row<INextCustomerService> }) => (
                        <TableCell
                            sx={refForm?.current[idx]?.addStyleNotView(row)}
                            align="left"
                            onMouseOver={(e: any) =>
                                refForm?.current[idx]?.changeToView(row)
                            }
                            onClick={() =>
                                refForm?.current[idx]?.handleClick(
                                    row.original.id,
                                    configPaths['customerService'],
                                )
                            }>
                            {row.original?.dateNextContact &&
                                formatDateWithoutHours(
                                    row.original.dateNextContact,
                                )}
                        </TableCell>
                    ),
                    header: () => (
                        <TableCell align={'left'} padding={'normal'}>
                            Data
                        </TableCell>
                    ),
                },
                {
                    accessorKey: 'diffInDays',
                    cell: ({ row }: { row: Row<INextCustomerService> }) => (
                        <TableCell
                            sx={refForm?.current[idx]?.addStyleNotView(row)}
                            align="left"
                            onMouseOver={(e: any) =>
                                refForm?.current[idx]?.changeToView(row)
                            }
                            onClick={() =>
                                refForm?.current[idx]?.handleClick(
                                    row.original.id,
                                    configPaths['customerService'],
                                )
                            }>
                            {_.isNumber(row.original?.diffInDays) &&
                                row.original.diffInDays}
                        </TableCell>
                    ),
                    header: () => (
                        <TableCell align={'left'} padding={'normal'}>
                            Dias faltantes
                        </TableCell>
                    ),
                },
                {
                    id: 'select',
                    header: ({ table }: any) => <TableCell align="center" />,
                    cell: ({ row }: any) => (
                        <TableCell align="right">
                            <Tooltip title={'Encerrar prazo/pendência'}>
                                <IconButton
                                    onClick={() => {
                                        refForm?.current[
                                            idx
                                        ]?.setIdInactiveNotification(
                                            row.original.id,
                                        );
                                        refForm?.current[
                                            idx
                                        ]?.setOpenModalInactiveNotification(
                                            true,
                                        );
                                    }}>
                                    <IconComponent icon={icons.ToggleOn} />
                                </IconButton>
                            </Tooltip>
                        </TableCell>
                    ),
                },
            ];
        },
        [
            listNotificationNextCustomerService,
            setListNotificationNextCustomerService,
        ],
    );

    const columnsTableNextTask = React.useCallback(
        (idx: number): ColumnDef<INextTask>[] => {
            return [
                {
                    accessorKey: 'finished',
                    cell: ({ row }: { row: Row<INextTask> }) => {
                        let index = row.index;

                        return (
                            <TableCell align="left">
                                <Checkbox
                                    name={`checkbox.${index}`}
                                    checked={row.original.finished}
                                    onChange={event => {
                                        applyCheckboxEvent({
                                            index,
                                            event,
                                            keyLocalStorage: NEXT_TASK,
                                            rows: listNotificationNextTask,
                                            setRows:
                                                setListNotificationNextTask,
                                        });
                                    }}
                                />
                            </TableCell>
                        );
                    },
                    header: () => (
                        <TableCell align={'left'} padding={'normal'}>
                            Encerrar prazo/pendência
                        </TableCell>
                    ),
                },
                {
                    id: 'customer.name',
                    header: () => (
                        <TableCell align={'left'} padding={'normal'}>
                            Cliente
                        </TableCell>
                    ),
                    cell: ({ row }: { row: Row<INextTask> }) => {
                        return (
                            <TableCell
                                sx={refForm?.current[idx]?.addStyleNotView(row)}
                                align="left"
                                key={row.id}
                                onMouseOver={(e: any) =>
                                    refForm?.current[idx]?.changeToView(row)
                                }
                                onClick={() =>
                                    refForm?.current[idx]?.handleClick(
                                        row.original.id,
                                        configPaths['task'],
                                    )
                                }>
                                {row.original?.customer?.name}
                            </TableCell>
                        );
                    },
                },
                {
                    id: 'urgency',
                    header: () => (
                        <TableCell align={'left'} padding={'normal'}>
                            Urgência
                        </TableCell>
                    ),
                    cell: ({ row }: { row: Row<INextTask> }) => {
                        return (
                            <TableCell
                                sx={refForm?.current[idx]?.addStyleNotView(row)}
                                align="left"
                                key={row.id}
                                onMouseOver={(e: any) =>
                                    refForm?.current[idx]?.changeToView(row)
                                }
                                onClick={() =>
                                    refForm?.current[idx]?.handleClick(
                                        row.original.id,
                                        configPaths['task'],
                                    )
                                }>
                                {row.original?.urgency &&
                                    enumInstances.urgencyOptionsInstance.getObject(
                                        row.original.urgency,
                                    )?.description}
                            </TableCell>
                        );
                    },
                },
                {
                    accessorKey: 'dateCustomerService',
                    cell: ({ row }: { row: Row<INextTask> }) => (
                        <TableCell
                            sx={refForm?.current[idx]?.addStyleNotView(row)}
                            align="left"
                            onMouseOver={(e: any) =>
                                refForm?.current[idx]?.changeToView(row)
                            }
                            onClick={() =>
                                refForm?.current[idx]?.handleClick(
                                    row.original.id,
                                    configPaths['task'],
                                )
                            }>
                            {row.original?.taskDeadLine &&
                                formatDateWithoutHours(
                                    row.original.taskDeadLine,
                                )}
                        </TableCell>
                    ),
                    header: () => (
                        <TableCell align={'left'} padding={'normal'}>
                            Data
                        </TableCell>
                    ),
                },
                {
                    accessorKey: 'diffInDays',
                    cell: ({ row }: { row: Row<INextTask> }) => (
                        <TableCell
                            sx={refForm?.current[idx]?.addStyleNotView(row)}
                            align="left"
                            onMouseOver={(e: any) =>
                                refForm?.current[idx]?.changeToView(row)
                            }
                            onClick={() =>
                                refForm?.current[idx]?.handleClick(
                                    row.original.id,
                                    configPaths['task'],
                                )
                            }>
                            {_.isNumber(row.original?.diffInDays) &&
                                row.original.diffInDays}
                        </TableCell>
                    ),
                    header: () => (
                        <TableCell align={'left'} padding={'normal'}>
                            Dias faltantes
                        </TableCell>
                    ),
                },
                {
                    id: 'status',
                    header: () => (
                        <TableCell align={'left'} padding={'normal'}>
                            Status
                        </TableCell>
                    ),
                    cell: ({ row }: { row: Row<INextTask> }) => {
                        return (
                            <TableCell
                                sx={refForm?.current[idx]?.addStyleNotView(row)}
                                align="left"
                                key={row.id}
                                onMouseOver={(e: any) =>
                                    refForm?.current[idx]?.changeToView(row)
                                }
                                onClick={() =>
                                    refForm?.current[idx]?.handleClick(
                                        row.original.id,
                                        configPaths['task'],
                                    )
                                }>
                                {row.original?.status &&
                                    enumInstances.taskSituationOptionsInstance.getObject(
                                        row.original.status,
                                    )?.description}
                            </TableCell>
                        );
                    },
                },
                {
                    id: 'select',
                    header: ({ table }: any) => <TableCell align="center" />,
                    cell: ({ row }: any) => (
                        <TableCell align="right">
                            <Tooltip title={'Encerrar prazo/pendência'}>
                                <IconButton
                                    onClick={() => {
                                        refForm?.current[
                                            idx
                                        ]?.setIdInactiveNotification(
                                            row.original.id,
                                        );
                                        refForm?.current[
                                            idx
                                        ]?.setOpenModalInactiveNotification(
                                            true,
                                        );
                                    }}>
                                    <IconComponent icon={icons.ToggleOn} />
                                </IconButton>
                            </Tooltip>
                        </TableCell>
                    ),
                },
            ];
        },
        [listNotificationNextTask, setListNotificationNextTask],
    );

    const modalRender = React.useMemo<IModalProps<any>[]>(
        () => [
            {
                open: notificationNextExpertise,
                setOpen: setNotificationNextExpertise,
                rows: listNotificationNextExpertise,
                setRows: setListNotificationNextExpertise,
                keyLocalStorage: '@GESSIS:nextExpertise',
                apiPath: 'expertise',
                route: paths.expertiseRegister,
                columns: columnsTableNextExpertise(0),
                title: 'Próximas perícias',
                width: width,
                quantity: listNotificationNextExpertise.filter(r => !r?.view)
                    .length,
                icon: <IconComponent icon={icons.Summarize} />,
            },
            {
                open: notificationNextLegalProcess,
                setOpen: setNotificationNextLegalProcess,
                rows: listNotificationNextLegalProcess,
                setRows: setListNotificationNextLegalProcess,
                keyLocalStorage: '@GESSIS:nextLegalProcess',
                apiPath: 'legal-process',
                route: paths.legalProcessRegister,
                columns: columnsTableNextLegalProcess(1),
                title: 'Próximos prazos de processos',
                width: width,
                quantity: listNotificationNextLegalProcess.filter(r => !r?.view)
                    .length,
                icon: <IconComponent icon={icons.Balance} />,
            },
            {
                open: notificationNextAudience,
                setOpen: setNotificationNextAudience,
                rows: listNotificationNextAudience,
                setRows: setListNotificationNextAudience,
                keyLocalStorage: '@GESSIS:nextAudience',
                apiPath: 'audiences',
                route: paths.audienceRegister,
                columns: columnsTableNextAudience(2),
                title: 'Próximas audiências',
                width: width,
                quantity: listNotificationNextAudience.filter(r => !r?.view)
                    .length,
                icon: <IconComponent icon={icons.Groups} />,
            },
            {
                open: notificationNextCustomerService,
                setOpen: setNotificationNextCustomerService,
                rows: listNotificationNextCustomerService,
                setRows: setListNotificationNextCustomerService,
                keyLocalStorage: '@GESSIS:nextCustomerService',
                apiPath: 'customer-services',
                route: paths.customerServiceRegister,
                columns: columnsTableNextCustomerService(3),
                title: 'Próximos contatos',
                width: width,
                quantity: listNotificationNextCustomerService.filter(
                    r => !r?.view,
                ).length,
                icon: <IconComponent icon={icons.PhonelinkRing} />,
            },
            {
                open: notificationNextTask,
                setOpen: setNotificationNextTask,
                rows: listNotificationNextTask,
                setRows: setListNotificationNextTask,
                keyLocalStorage: '@GESSIS:nextTask',
                apiPath: 'tasks',
                route: paths.taskRegister,
                columns: columnsTableNextTask(4),
                title: 'Próximas tarefas',
                width: width,
                quantity: listNotificationNextTask.filter(r => !r?.view).length,
                icon: <IconComponent icon={icons.PlaylistAddCheck} />,
            },
        ],
        [
            notificationNextExpertise,
            setNotificationNextExpertise,
            listNotificationNextExpertise,
            setListNotificationNextExpertise,
            columnsTableNextExpertise,
            width,
            notificationNextLegalProcess,
            setNotificationNextLegalProcess,
            listNotificationNextLegalProcess,
            setListNotificationNextLegalProcess,
            columnsTableNextLegalProcess,
            notificationNextAudience,
            setNotificationNextAudience,
            listNotificationNextAudience,
            setListNotificationNextAudience,
            columnsTableNextAudience,
            notificationNextCustomerService,
            setNotificationNextCustomerService,
            listNotificationNextCustomerService,
            setListNotificationNextCustomerService,
            columnsTableNextCustomerService,
            notificationNextTask,
            setNotificationNextTask,
            listNotificationNextTask,
            setListNotificationNextTask,
            columnsTableNextTask,
        ],
    );

    const { user } = useAuth();

    const additionalQueryInCrudUser = () => {
        if (user?.typeUser === 'user') {
            return `&${setTypeUserInQuery(user.typeUser)}`;
        }
        return '';
    };

    const menuItems = React.useMemo<IListItem[]>(
        () => [
            {
                icon: <IconComponent icon={icons.AddCard} />,
                onClick: () => {
                    handleOpenCollapseRecords(!openCollapseRecords);
                },
                name: 'Cadastros',
                open: openCollapseRecords,
                dataQa: 'menu-registrations',
                childrens: [
                    {
                        icon: <IconComponent icon={icons.AccountCircle} />,
                        sx: {
                            ...notApplyDisplayNone(
                                user.permissions['user_execute'],
                            ),
                        },
                        to: `/records/user?limit=${
                            rowsPerPageOptions[0]
                        }&page=1${additionalQueryInCrudUser()}`,
                        name: 'Usuários',
                        dataQa: 'crud-user',
                    },
                    {
                        icon: <IconComponent icon={icons.Cable} />,
                        sx: null,
                        to: `/records/origin-type?limit=${rowsPerPageOptions[0]}&page=1`,
                        name: 'Tipos de origens',
                        dataQa: 'crud-origin-type',
                    },
                    {
                        icon: <IconComponent icon={icons.MoneyOffCsred} />,
                        sx: null,
                        to: `${paths.originExpenditure}?limit=${rowsPerPageOptions[0]}&page=1`,
                        name: 'Tipos de despesas',
                        dataQa: 'crud-origin-expenditure',
                    },
                    {
                        icon: <IconComponent icon={icons.AccountBox} />,
                        sx: null,
                        to: `/records/customer?limit=${rowsPerPageOptions[0]}&page=1`,
                        name: 'Clientes',
                        dataQa: 'crud-customer',
                    },
                    {
                        icon: <IconComponent icon={icons.Business} />,
                        sx: {
                            ...notApplyDisplayNone(
                                user.permissions['company_execute'],
                            ),
                        },
                        to: `${paths.company}?limit=${rowsPerPageOptions[0]}&page=1`,
                        name: 'Empresas',
                        dataQa: 'crud-company',
                    },
                    {
                        icon: <IconComponent icon={icons.EditRoad} />,
                        sx: null,
                        to: `/records/district`,
                        name: 'Bairros',
                        dataQa: 'crud-district',
                    },
                    {
                        icon: <IconComponent icon={icons.MemoryOutlined} />,
                        sx: null,
                        to: `/records/configuration?limit=${rowsPerPageOptions[0]}&page=1`,
                        name: 'Configurações',
                        dataQa: 'crud-configuration',
                    },
                    {
                        icon: <IconComponent icon={icons.Flag} />,
                        sx: null,
                        to: `/records/legal-process-district?limit=${rowsPerPageOptions[0]}&page=1`,
                        name: 'Comarca',
                        dataQa: 'crud-legal-process-district',
                    },
                    {
                        icon: <IconComponent icon={icons.StickyNote2} />,
                        sx: null,
                        to: `/records/stick?limit=${rowsPerPageOptions[0]}&page=1`,
                        name: 'Vara',
                        dataQa: 'crud-stick',
                    },
                    {
                        icon: <IconComponent icon={icons.GraphicEq} />,
                        sx: null,
                        to: `/records/qualification?limit=${rowsPerPageOptions[0]}&page=1`,
                        name: 'Qualificação',
                        dataQa: 'crud-qualification',
                    },
                    {
                        icon: <IconComponent icon={icons.AccountTree} />,
                        sx: null,
                        to: `/records/instance?limit=${rowsPerPageOptions[0]}&page=1`,
                        name: 'Instância',
                        dataQa: 'crud-instance',
                    },
                ],
            },
            {
                icon: <IconComponent icon={icons.Summarize} />,
                onClick: () => {
                    closeAll();
                },
                to: `/records/expertise`,
                name: 'Perícias',
                dataQa: 'crud-expertise',
                childrens: [],
            },
            {
                icon: <IconComponent icon={icons.Archive} />,
                onClick: () => {
                    closeAll();
                },
                to: `${paths.fileTemplate}`,
                name: 'Templates de arquivos',
                dataQa: 'crud-file-template',
                childrens: [],
            },
            {
                icon: <IconComponent icon={icons.Balance} />,
                onClick: () => {
                    closeAll();
                },
                to: `/records/legal-process`,
                name: 'Processos',
                dataQa: 'crud-legal-process',
                childrens: [],
            },
            {
                icon: <IconComponent icon={icons.Groups} />,
                onClick: () => {
                    closeAll();
                },
                to: `/records/audience`,
                name: 'Audiências',
                dataQa: 'crud-audience',
                childrens: [],
            },
            {
                icon: <IconComponent icon={icons.PhonelinkRing} />,
                onClick: () => {
                    closeAll();
                },
                to: `/records/customer-service`,
                name: 'Atendimentos',
                dataQa: 'crud-customer-service',
                childrens: [],
            },
            {
                icon: <IconComponent icon={icons.PlaylistAddCheck} />,
                onClick: () => {
                    closeAll();
                },
                to: `/records/task`,
                name: 'Tarefas',
                dataQa: 'crud-task',
                childrens: [],
            },
            {
                icon: <IconComponent icon={icons.BusinessCenter} />,
                onClick: () => {
                    closeAll();
                },
                to: `/records/additional-honorarium`,
                name: 'Honorários',
                dataQa: 'crud-additional-honorarium',
                childrens: [],
            },
            {
                icon: <IconComponent icon={icons.LocalAtm} />,
                onClick: () => {
                    closeAll();
                },
                sx: {
                    ...notApplyDisplayNone(user.permissions['comission_list']),
                },
                to: `/records/commission`,
                name: 'Comissões',
                dataQa: 'crud-commission',
                childrens: [],
            },
            {
                icon: <IconComponent icon={icons.MoneyOff} />,
                onClick: () => {
                    closeAll();
                },
                to: `${paths.additionalExpense}`,
                name: 'Despesas adicionais',
                dataQa: 'crud-additional-expense',
                childrens: [],
            },
            {
                icon: <IconComponent icon={icons.CurrencyExchange} />,
                onClick: () => {
                    handleOpenCollapseInvoicing(!openCollapseInvoicing);
                },
                name: 'Faturamentos',
                open: openCollapseInvoicing,
                dataQa: 'menu-invoicing',
                childrens: [
                    {
                        icon: <IconComponent icon={icons.PriceCheck} />,
                        sx: null,
                        to: `${paths.invoiceDetailList}`,
                        name: 'Gerar faturas',
                        dataQa: 'crud-invoice-details',
                    },
                    {
                        icon: <IconComponent icon={icons.Paid} />,
                        sx: null,
                        to: `${paths.invoiceDetail}`,
                        name: 'Baixa de faturas',
                        dataQa: 'invoice-details',
                    },
                    {
                        icon: <IconComponent icon={icons.RequestQuote} />,
                        sx: null,
                        to: `${paths.generatedInvoices}`,
                        name: 'Faturas geradas',
                        dataQa: 'generated-invoices',
                    },
                    {
                        icon: <IconComponent icon={icons.Archive} />,
                        sx: {
                            ...notApplyDisplayNone(
                                user.permissions['withdrawn_execute'],
                            ),
                        },
                        to: `${paths.withdrawn}`,
                        name: 'Fechamentos de caixas',
                        dataQa: 'withdrawn',
                    },
                ],
            },
            {
                icon: <IconComponent icon={icons.LockOutlined} />,
                onClick: () => {
                    handleOpenCollapsePermissions(!openCollapsePermissions);
                },
                sx: {
                    ...notApplyDisplayNone(
                        user.typeUser === 'admin' ||
                            user.permissions['right_execute'] ||
                            user.permissions['role_execute'],
                    ),
                },
                name: 'Permissões',
                open: openCollapsePermissions,
                dataQa: 'menu-permissions',
                childrens: [
                    {
                        icon: (
                            <IconComponent icon={icons.PermIdentityOutlined} />
                        ),
                        sx: {
                            ...notApplyDisplayNone(user.typeUser === 'admin'),
                        },
                        to: `${paths.permission}`,
                        name: 'Permissão',
                        dataQa: 'crud-permission',
                    },
                    {
                        icon: <IconComponent icon={icons.SwipeRight} />,
                        sx: {
                            ...notApplyDisplayNone(
                                user.permissions['right_execute'],
                            ),
                        },
                        to: `${paths.right}`,
                        name: 'Direitos de usuário',
                        dataQa: 'crud-right',
                    },
                    {
                        icon: <IconComponent icon={icons.Functions} />,
                        sx: {
                            ...notApplyDisplayNone(
                                user.permissions['role_execute'],
                            ),
                        },
                        to: `${paths.role}`,
                        name: 'Papéis',
                        dataQa: 'crud-role',
                    },
                ],
            },
        ],
        [
            openCollapseRecords,
            openCollapseInvoicing,
            openCollapsePermissions,
            openCollapseExpenditurePortions,
            user,
        ],
    );

    const handleClose = () => {
        setAnchorEl(null);
    };

    const openAnchor = Boolean(anchorEl);
    const id = openAnchor ? 'simple-popover' : undefined;

    const [open, setOpen] = React.useState(true);
    const toggleDrawer = () => {
        setOpen(!open);
    };

    function closeAll() {
        handleOpenCollapseRecords(false);
    }

    const handleDrawerClose = () => {
        setOpen(false);
    };

    const numberUnseenNotifications = React.useCallback(() => {
        let quantity = 0;
        if (Array.isArray(listNotificationNextExpertise)) {
            listNotificationNextExpertise.forEach(item => {
                if (!item?.view) {
                    quantity += 1;
                }
            });
        }

        if (Array.isArray(listNotificationNextLegalProcess)) {
            listNotificationNextLegalProcess.forEach(item => {
                if (!item?.view) {
                    quantity += 1;
                }
            });
        }

        if (Array.isArray(listNotificationNextAudience)) {
            listNotificationNextAudience.forEach(item => {
                if (!item?.view) {
                    quantity += 1;
                }
            });
        }

        if (Array.isArray(listNotificationNextCustomerService)) {
            listNotificationNextCustomerService.forEach(item => {
                if (!item?.view) {
                    quantity += 1;
                }
            });
        }

        if (Array.isArray(listNotificationNextTask)) {
            listNotificationNextTask.forEach(item => {
                if (!item?.view) {
                    quantity += 1;
                }
            });
        }

        return quantity;
    }, [
        listNotificationNextAudience,
        listNotificationNextCustomerService,
        listNotificationNextExpertise,
        listNotificationNextLegalProcess,
        listNotificationNextTask,
    ]);

    const configPaths = {
        expertise: paths.expertiseRegister,
        legalProcess: paths.legalProcessRegister,
        audience: paths.audienceRegister,
        customerService: paths.customerServiceRegister,
        task: paths.taskRegister,
    };

    const handleConfirmViewInventory = async (confirm: boolean) => {
        if (confirm) {
            setNotificationNextAudience(false);
            setOpenModalNextAudience(true);
        } else {
            setNotificationNextAudience(false);
        }
    };

    function useWindowSize() {
        const [size, setSize] = React.useState([0, 0]);
        React.useLayoutEffect(() => {
            function updateSize() {
                setSize([window.innerWidth, window.innerHeight]);
            }
            window.addEventListener('resize', updateSize);
            updateSize();
            return () => window.removeEventListener('resize', updateSize);
        }, []);
        return size;
    }

    React.useEffect(() => {
        if (window.screen.width < 800) {
            setOpen(false);
        }
    }, [width]);

    React.useEffect(() => {
        const regex = /\((0*[1-9][0-9]*)\)/;

        let quantityNotification = numberUnseenNotifications();

        if (quantityNotification > 0) {
            const validRegex = new RegExp(regex).test(document.title);
            if (validRegex) {
                document.title = document.title.replace(
                    regex,
                    `(${quantityNotification})`,
                );
            } else {
                document.title += ` (${quantityNotification})`;
            }
        } else {
            const validRegex = new RegExp(regex).test(document.title);
            if (validRegex) {
                document.title = document.title.replace(regex, '');
            }
        }
    }, [
        listNotificationNextExpertise,
        listNotificationNextLegalProcess,
        listNotificationNextAudience,
        listNotificationNextCustomerService,
        listNotificationNextTask,
        numberUnseenNotifications,
    ]);

    return (
        <div id="root">
            {modalRender.map((item, idx) => {
                return (
                    <ModalNext
                        key={item.apiPath}
                        open={item.open}
                        setOpen={item.setOpen}
                        rows={item.rows}
                        setRows={item.setRows}
                        keyLocalStorage={item.keyLocalStorage}
                        apiPath={item.apiPath}
                        route={item.route}
                        columns={item.columns}
                        title={item.title}
                        width={width}
                        icon={item.icon}
                        quantity={item.quantity}
                        ref={el => (refForm.current[idx] = el)}
                    />
                );
            })}
            <ModalAward
                open={openModalAwardedCustomers}
                setOpen={setOpenModalAwardedCustomers}
                rows={listAwardedCustomers}
                setListAwardedCustomers={setListAwardedCustomers}
                width={width}
            />
            <ModalBirthDayCustomer
                open={openModalBirthday}
                setOpen={setOpenModalBirthday}
                rows={listBirthdays}
                setRows={setListBirthdays}
                width={width}
            />
            <ModalOverdueInstallment
                open={openModalOverdueInstallments}
                setOpen={setOpenModalOverdueInstallments}
                rows={listOverdueInstallments}
                width={width}
            />
            <Box sx={{ display: 'flex', height: '100vh' }}>
                <CssBaseline />
                {/* <AlertDialog
                    handleConfirmation={handleConfirmViewInventory}
                    open={notificationNextAudience}
                    messageDialogTitle={'Deseja abrir as próximas audiências?'}
                /> */}
                <AppBar position="fixed" open={open}>
                    <Toolbar className="toolbar">
                        <IconButton
                            edge="start"
                            color="inherit"
                            aria-label="open drawer"
                            onClick={toggleDrawer}
                            sx={{
                                marginRight:
                                    window.screen.width < 800 ? '8px' : '16px',
                                ...(open && { display: 'none' }),
                            }}>
                            <MenuIcon />
                        </IconButton>

                        <Typography
                            component="h1"
                            variant="h6"
                            color="inherit"
                            noWrap
                            data-qa="dashboard"
                            onClick={() => history.push('/dashboard')}
                            sx={{ flexGrow: 1, cursor: 'pointer' }}>
                            GESSIS
                        </Typography>

                        {/* <Tooltip title={titleMessages.birthDays}>
                            <IconButton
                                color="inherit"
                                onClick={() =>
                                    setOpenModalBirthday(true)
                                }>
                                <Badge
                                    badgeContent={
                                        listBirthdays.filter(r => !r.view)
                                            .length
                                    }
                                    color="secondary">
                                    <SentimentVerySatisfiedOutlinedIcon />
                                </Badge>
                            </IconButton>
                        </Tooltip> */}

                        {/* <Tooltip title={titleMessages.nextAudience}>
                            <IconButton
                                color="inherit"
                                onClick={event =>
                                    setOpenModalNextAudience(true)
                                }>
                                <Badge
                                    badgeContent={
                                        listNotificationNextAudience.filter(
                                            r => !r.view,
                                        ).length
                                    }
                                    color="secondary">
                                    <NotificationsIcon />
                                </Badge>
                            </IconButton>
                        </Tooltip> */}
                        {modalRender.map(notificationItem => {
                            return (
                                <Tooltip
                                    key={notificationItem.apiPath}
                                    title={notificationItem.title}>
                                    <IconButton
                                        color="inherit"
                                        onClick={event =>
                                            notificationItem.setOpen(true)
                                        }>
                                        <Badge
                                            badgeContent={
                                                notificationItem.quantity
                                            }
                                            color="secondary">
                                            {notificationItem.icon}
                                        </Badge>
                                    </IconButton>
                                </Tooltip>
                            );
                        })}

                        <Popover
                            id={id}
                            open={openAnchor}
                            anchorEl={anchorEl}
                            onClose={handleClose}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'left',
                            }}>
                            <div style={{ width: 500 }}>
                                <Typography sx={{ p: 2 }}>
                                    The content of the Popover.
                                </Typography>
                            </div>
                        </Popover>

                        <LongMenu />
                    </Toolbar>
                </AppBar>
                <Drawer
                    sx={{
                        width: open ? drawerWidth : 0,
                        flexShrink: 0,
                        '& .MuiDrawer-paper': {
                            width: open ? drawerWidth : 0,
                            boxSizing: 'border-box',
                        },
                    }}
                    variant="persistent"
                    anchor="left"
                    open={open}>
                    <DrawerHeader>
                        <IconButton onClick={handleDrawerClose}>
                            {theme.direction === 'ltr' ? (
                                <ChevronLeftIcon />
                            ) : (
                                <ChevronRightIcon />
                            )}
                        </IconButton>
                    </DrawerHeader>
                    <Divider />
                    <Switch>
                        <React.Fragment>
                            <RenderList items={menuItems} />
                            {/* <List component="nav">
                                <ListItem
                                    button
                                    onClick={() =>
                                        handleOpenCollapseRecords(
                                            !openCollapseRecords,
                                        )
                                    }>
                                    <ListItemIcon sx={styleListIcon}>
                                        <AddCard />
                                    </ListItemIcon>
                                    <ListItemText primary="Cadastros" />
                                    {openCollapseRecords ? (
                                        <ExpandLess />
                                    ) : (
                                        <ExpandMore />
                                    )}
                                </ListItem>
                                <Collapse
                                    in={openCollapseRecords}
                                    timeout="auto"
                                    unmountOnExit>
                                    <ListItem
                                        button
                                        sx={{
                                            ...notApplyDisplayNone(
                                                !user.permissions[
                                                    'user_execute'
                                                ],
                                            ),
                                        }}
                                        component={Link}
                                        to={`/records/user?limit=${rowsPerPageOptions[0]}&page=1`}>
                                        <ListItemButton>
                                            <ListItemIcon sx={styleListIcon}>
                                                <AccountCircleIcon />
                                            </ListItemIcon>
                                            <ListItemText primary="Usuários" />
                                        </ListItemButton>
                                    </ListItem>
                                    <ListItem
                                        button
                                        component={Link}
                                        to={`/records/origin-type?limit=${rowsPerPageOptions[0]}&page=1`}>
                                        <ListItemButton>
                                            <ListItemIcon sx={styleListIcon}>
                                                <IconComponent
                                                    icon={icons.Cable}
                                                />
                                            </ListItemIcon>
                                            <ListItemText primary="Tipos de origens" />
                                        </ListItemButton>
                                    </ListItem>
                                    <ListItem
                                        button
                                        component={Link}
                                        to={`${paths.originExpenditure}?limit=${rowsPerPageOptions[0]}&page=1`}>
                                        <ListItemButton>
                                            <ListItemIcon sx={styleListIcon}>
                                                <IconComponent
                                                    icon={icons.MoneyOffCsred}
                                                />
                                            </ListItemIcon>
                                            <ListItemText primary="Tipos de despesas" />
                                        </ListItemButton>
                                    </ListItem>
                                    <ListItem
                                        button
                                        component={Link}
                                        to={`/records/customer?limit=${rowsPerPageOptions[0]}&page=1`}>
                                        <ListItemButton>
                                            <ListItemIcon sx={styleListIcon}>
                                                <AccountBoxIcon />
                                            </ListItemIcon>
                                            <ListItemText primary="Clientes" />
                                        </ListItemButton>
                                    </ListItem>
                                    <ListItem
                                        button
                                        sx={{
                                            ...notApplyDisplayNone(
                                                !user.permissions[
                                                    'company_execute'
                                                ],
                                            ),
                                        }}
                                        component={Link}
                                        to={`${paths.company}?limit=${rowsPerPageOptions[0]}&page=1`}>
                                        <ListItemButton>
                                            <ListItemIcon sx={styleListIcon}>
                                                <IconComponent
                                                    icon={icons.Business}
                                                />
                                            </ListItemIcon>
                                            <ListItemText primary="Empresas" />
                                        </ListItemButton>
                                    </ListItem>
                                    <ListItem
                                        button
                                        component={Link}
                                        to="/records/district">
                                        <ListItemButton>
                                            <ListItemIcon sx={styleListIcon}>
                                                <EditRoadIcon />
                                            </ListItemIcon>
                                            <ListItemText primary="Bairros" />
                                        </ListItemButton>
                                    </ListItem>
                                    <ListItem
                                        button
                                        component={Link}
                                        to={`/records/configuration?limit=${rowsPerPageOptions[0]}&page=1`}>
                                        <ListItemButton>
                                            <ListItemIcon sx={styleListIcon}>
                                                <MemoryOutlinedIcon />
                                            </ListItemIcon>
                                            <ListItemText primary="Configurações" />
                                        </ListItemButton>
                                    </ListItem>
                                    <ListItem
                                        button
                                        component={Link}
                                        to={`/records/legal-process-district?limit=${rowsPerPageOptions[0]}&page=1`}>
                                        <ListItemButton>
                                            <ListItemIcon sx={styleListIcon}>
                                                <MemoryOutlinedIcon />
                                            </ListItemIcon>
                                            <ListItemText primary="Comarca" />
                                        </ListItemButton>
                                    </ListItem>
                                </Collapse>
                                <ListItemButton
                                    data-qa="listItemButton-legalProcess"
                                    component={Link}
                                    onClick={closeAll}
                                    to={`/records/legal-process`}>
                                    <ListItemIcon sx={styleListIcon}>
                                        <DashboardIcon />
                                    </ListItemIcon>
                                    <ListItemText primary="Processos" />
                                </ListItemButton>
                                <ListItemButton
                                    component={Link}
                                    onClick={closeAll}
                                    to={`/records/additional-honorarium`}>
                                    <ListItemIcon sx={styleListIcon}>
                                        <IconComponent
                                            icon={icons.BusinessCenter}
                                        />
                                    </ListItemIcon>
                                    <ListItemText primary="Honorários adicionais" />
                                </ListItemButton>
                                <ListItemButton
                                    component={Link}
                                    onClick={closeAll}
                                    to={`${paths.additionalExpense}`}>
                                    <ListItemIcon sx={styleListIcon}>
                                        <IconComponent icon={icons.MoneyOff} />
                                    </ListItemIcon>
                                    <ListItemText primary="Despesas adicionais" />
                                </ListItemButton>
                                <ListItem
                                    button
                                    onClick={() =>
                                        handleOpenCollapseInvoicing(
                                            !openCollapseInvoicing,
                                        )
                                    }>
                                    <ListItemIcon sx={styleListIcon}>
                                        <IconComponent
                                            icon={icons.CurrencyExchange}
                                        />
                                    </ListItemIcon>
                                    <ListItemText primary="Faturamentos" />
                                    {openCollapseInvoicing ? (
                                        <ExpandLess />
                                    ) : (
                                        <ExpandMore />
                                    )}
                                </ListItem>
                                <Collapse
                                    in={openCollapseInvoicing}
                                    timeout="auto"
                                    unmountOnExit>
                                    <ListItem
                                        button
                                        component={Link}
                                        to={`${paths.invoiceDetailList}`}>
                                        <ListItemButton>
                                            <ListItemIcon sx={styleListIcon}>
                                                <IconComponent
                                                    icon={icons.PriceCheck}
                                                />
                                            </ListItemIcon>
                                            <ListItemText primary="Gerar faturas" />
                                        </ListItemButton>
                                    </ListItem>
                                    <ListItem
                                        button
                                        component={Link}
                                        to={paths.invoiceDetail}>
                                        <ListItemButton>
                                            <ListItemIcon sx={styleListIcon}>
                                                <IconComponent
                                                    icon={icons.Paid}
                                                />
                                            </ListItemIcon>
                                            <ListItemText primary="Baixa de faturas" />
                                        </ListItemButton>
                                    </ListItem>
                                    <ListItem
                                        button
                                        component={Link}
                                        to={paths.generatedInvoices}>
                                        <ListItemButton>
                                            <ListItemIcon sx={styleListIcon}>
                                                <IconComponent
                                                    icon={icons.RequestQuote}
                                                />
                                            </ListItemIcon>
                                            <ListItemText primary="Faturas geradas" />
                                        </ListItemButton>
                                    </ListItem>
                                    <ListItem
                                        button
                                        sx={{
                                            ...notApplyDisplayNone(
                                                !user.permissions[
                                                    'withdrawn_execute'
                                                ],
                                            ),
                                        }}
                                        component={Link}
                                        to={paths.withdrawn}>
                                        <ListItemButton>
                                            <ListItemIcon sx={styleListIcon}>
                                                <IconComponent
                                                    icon={icons.Archive}
                                                />
                                            </ListItemIcon>
                                            <ListItemText primary="Fechamentos de caixas" />
                                        </ListItemButton>
                                    </ListItem>
                                </Collapse>
                                <ListItem
                                    button
                                    sx={{
                                        ...notApplyDisplayNone(
                                            user.typeUser !== 'admin',
                                        ),
                                    }}
                                    onClick={() =>
                                        handleOpenCollapsePermissions(
                                            !openCollapsePermissions,
                                        )
                                    }>
                                    <ListItemIcon sx={styleListIcon}>
                                        <IconComponent
                                            icon={icons.LockOutlined}
                                        />
                                    </ListItemIcon>
                                    <ListItemText primary="Permissões" />
                                    {openCollapsePermissions ? (
                                        <ExpandLess />
                                    ) : (
                                        <ExpandMore />
                                    )}
                                </ListItem>
                                <Collapse
                                    in={openCollapsePermissions}
                                    timeout="auto"
                                    unmountOnExit>
                                    <ListItem
                                        button
                                        sx={{
                                            ...notApplyDisplayNone(
                                                user.typeUser !== 'admin',
                                            ),
                                        }}
                                        component={Link}
                                        to={`${paths.permission}`}>
                                        <ListItemButton>
                                            <ListItemIcon sx={styleListIcon}>
                                                <IconComponent
                                                    icon={
                                                        icons.PermIdentityOutlined
                                                    }
                                                />
                                            </ListItemIcon>
                                            <ListItemText primary="Permissão" />
                                        </ListItemButton>
                                    </ListItem>
                                    <ListItem
                                        button
                                        sx={{
                                            ...notApplyDisplayNone(
                                                user.typeUser !== 'admin',
                                            ),
                                        }}
                                        component={Link}
                                        to={paths.right}>
                                        <ListItemButton>
                                            <ListItemIcon sx={styleListIcon}>
                                                <IconComponent
                                                    icon={icons.SwipeRight}
                                                />
                                            </ListItemIcon>
                                            <ListItemText primary="Direitos de usuário" />
                                        </ListItemButton>
                                    </ListItem>
                                    <ListItem
                                        button
                                        sx={{
                                            ...notApplyDisplayNone(
                                                user.typeUser !== 'admin',
                                            ),
                                        }}
                                        component={Link}
                                        to={paths.role}>
                                        <ListItemButton>
                                            <ListItemIcon sx={styleListIcon}>
                                                <IconComponent
                                                    icon={icons.Functions}
                                                />
                                            </ListItemIcon>
                                            <ListItemText primary="Papéis" />
                                        </ListItemButton>
                                    </ListItem>
                                </Collapse>
                            </List> */}
                        </React.Fragment>
                    </Switch>
                </Drawer>

                <Main
                    open={open}
                    className="main-container"
                    sx={{
                        backgroundColor: theme =>
                            theme.palette.mode === 'light'
                                ? theme.palette.grey[100]
                                : theme.palette.grey[900],
                        display: 'flex',
                        flexDirection: 'column',
                        p: 0,
                    }}>
                    <DrawerHeader />
                    <Box
                        className="main-box"
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            height: '100%',
                            overflow: 'auto',
                            width: '100%',
                        }}>
                        {children}
                    </Box>

                    <Footer />
                </Main>

                {/* <div className="container-test"></div> */}
            </Box>
        </div>
    );
};

const style = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '1000px',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 2,
    borderRadius: '4px',
    minHeight: 500,
};

function ModalNextAudience({
    open,
    setOpen,
    rows,
    setRows,
    width,
}: ModalProps) {
    const history = useHistory();
    const { addToast } = useToast();

    const handleClose = () => {
        setOpen(false);
    };

    const handleClick = (id: string, row: any) => {
        changeToView(row);
        history.push(`${paths.legalProcessRegister}/${id}`);
    };

    const styleModal = {
        ...style,
    };

    if (width <= 800) {
        styleModal.width = '90%';
    }

    const listView = rows.filter(r => !r.view).map(r => r.id);
    if (open && listView.length > 0) {
        api.patch(`notification/view/1`, {
            ids: [...listView],
        })
            .then(_ => {
                changeRowsToView();
            })
            .catch(error => {
                const messagesResponse = handleExceptionMultipleMessages(error);
                for (const messageResponse of messagesResponse) {
                    addToast({
                        type: 'error',
                        title: message.error.save,
                        description: messageResponse,
                    });
                }
            });
    }

    const addStyleNotView = (row: any) => {
        return {
            ...(!row.original.visited
                ? {
                      fontWeight: 'bold',
                  }
                : {}),
        };
    };

    const changeRowsToView = () => {
        let items: any = localStorage.getItem('@GESSIS:nextAudience');
        if (items) {
            items = JSON.parse(items);
        }

        items = items.map((item: any) => ({ ...item, view: true }));
        localStorage.setItem('@GESSIS:nextAudience', JSON.stringify(items));
        setRows(items);
    };

    const changeRowsToUpdate = (row: any) => {
        let items: any = localStorage.getItem('@GESSIS:nextAudience');
        if (items) {
            items = JSON.parse(items);
        }

        const indexList = items.findIndex((r: any) => r.id == row.original.id);
        if (indexList >= 0) {
            items[indexList].visited = true;
        }
        localStorage.setItem('@GESSIS:nextAudience', JSON.stringify(items));
        setRows(items);
    };

    const changeRowsToDelete = (row: any) => {
        let items: any = localStorage.getItem('@GESSIS:nextAudience');
        if (items) {
            items = JSON.parse(items);
        }

        items = items.filter((r: any) => r.id !== row.original.id);
        localStorage.setItem('@GESSIS:nextAudience', JSON.stringify(items));
        setRows(items);
    };

    function changeToView(row: any) {
        if (!row.visited) {
            api.patch(`notification/visited/1`, {
                ids: [row.original.id],
            })
                .then(_ => {
                    changeRowsToUpdate(row);
                })
                .catch(error => {
                    const messagesResponse =
                        handleExceptionMultipleMessages(error);
                    for (const messageResponse of messagesResponse) {
                        addToast({
                            type: 'error',
                            title: message.error.save,
                            description: messageResponse,
                        });
                    }
                });
        }
    }

    function deleteItem(row: any) {
        api.patch(`notification/active/0`, {
            ids: [row.original.id],
        })
            .then(_ => {
                changeRowsToDelete(row);
            })
            .catch(error => {
                const messagesResponse = handleExceptionMultipleMessages(error);
                for (const messageResponse of messagesResponse) {
                    addToast({
                        type: 'error',
                        title: message.error.delete,
                        description: messageResponse,
                    });
                }
            });
    }

    function handleDaysLeft(row: any) {
        const diff = momentDiff(row.original.body.dateHearing, 'days');

        if (diff > 0) {
            return diff;
        }
        if (diff < 0) {
            return 0;
        }
        return 'Hoje';
    }

    const columnsTable = React.useMemo<ColumnDef<Data>[]>(
        () => [
            {
                id: 'select',
                header: () => (
                    <TableCell align={'left'} padding={'normal'}>
                        Número do processo
                    </TableCell>
                ),
                cell: ({ row }: { row: Row<Data> }) => {
                    return (
                        <TableCell
                            sx={addStyleNotView(row)}
                            align="left"
                            key={row.id}
                            // onMouseOver={(e: any) => changeToView(row)}
                            onClick={() =>
                                handleClick(row.original.body.id, row)
                            }>
                            {row.original?.body?.processNumber}
                        </TableCell>
                    );
                },
            },
            {
                id: 'select',
                header: () => (
                    <TableCell align={'left'} padding={'normal'}>
                        Cliente
                    </TableCell>
                ),
                cell: ({ row }: any) => {
                    return (
                        <TableCell
                            sx={addStyleNotView(row)}
                            align="left"
                            key={row.id}
                            // onMouseOver={(e: any) => changeToView(row)}
                            onClick={() =>
                                handleClick(row.original.body.id, row)
                            }>
                            {row.original?.body?.customer?.name}
                        </TableCell>
                    );
                },
            },
            {
                id: 'select',
                header: () => (
                    <TableCell align={'left'} padding={'normal'}>
                        Descrição
                    </TableCell>
                ),
                cell: ({ row }: any) => {
                    return (
                        <TableCell
                            sx={addStyleNotView(row)}
                            align="left"
                            key={row.id}
                            // onMouseOver={(e: any) => changeToView(row)}
                            onClick={() =>
                                handleClick(row.original.body.id, row)
                            }>
                            {row.original?.body?.description}
                        </TableCell>
                    );
                },
            },
            {
                accessorKey: 'situation',
                cell: (cell: any) => {
                    return (
                        <TableCell
                            sx={addStyleNotView(cell.row)}
                            align="left"
                            // onMouseOver={(e: any) => changeToView(cell.row)}
                            onClick={() =>
                                handleClick(cell.row.original.body.id, cell.row)
                            }>
                            {
                                instanceStateOptions.getObject(
                                    cell.row.original.body.situation,
                                )?.description
                            }
                        </TableCell>
                    );
                },
                header: () => (
                    <TableCell align={'left'} padding={'normal'}>
                        Situação
                    </TableCell>
                ),
            },
            {
                accessorKey: 'dateHearing',
                cell: (cell: any) => (
                    <TableCell
                        sx={addStyleNotView(cell.row)}
                        align="left"
                        // onMouseOver={(e: any) => changeToView(cell.row)}
                        onClick={() =>
                            handleClick(cell.row.original.body.id, cell.row)
                        }>
                        {formatDateWithoutHours(
                            cell.row.original.body.dateHearing,
                        )}
                    </TableCell>
                ),
                header: () => (
                    <TableCell align={'left'} padding={'normal'}>
                        Data audiência
                    </TableCell>
                ),
            },
            {
                accessorKey: 'dateHearing',
                cell: (cell: any) => (
                    <TableCell
                        sx={addStyleNotView(cell.row)}
                        align="left"
                        // onMouseOver={(e: any) => changeToView(cell.row)}
                        onClick={() =>
                            handleClick(cell.row.original.body.id, cell.row)
                        }>
                        {handleDaysLeft(cell.row)}
                    </TableCell>
                ),
                header: () => (
                    <TableCell align={'left'} padding={'normal'}>
                        Quantos dias faltam
                    </TableCell>
                ),
            },
            {
                id: 'select',
                header: ({ table }: any) => <TableCell align="center" />,
                cell: ({ row }: any) => (
                    <TableCell align="right">
                        <Tooltip
                            title="Remover notificação"
                            onClick={() => {
                                deleteItem(row);
                            }}>
                            <IconButton>
                                <IconComponent icon={icons.Delete} />
                            </IconButton>
                        </Tooltip>
                    </TableCell>
                ),
            },
        ],
        [],
    );

    return (
        <div>
            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description">
                <Box sx={styleModal} component={'div'}>
                    <div className="header-modal">
                        <Typography
                            id="modal-modal-title"
                            variant="h6"
                            component="h2">
                            {titleMessages.nextAudience}
                        </Typography>
                        <IconButton onClick={handleClose}>
                            <CloseIcon />
                        </IconButton>
                    </div>
                    <TableGeneric
                        data={rows}
                        columns={columnsTable}
                        minWidth={650}
                        sxTableContainer={{
                            height: width <= 800 ? 400 : 600,
                            '&::-webkit-scrollbar': {
                                width: 8,
                            },
                            '&::-webkit-scrollbar-track': {
                                backgroundColor: '#f1f1f1',
                                borderRadius: 2,
                            },
                            '&::-webkit-scrollbar-thumb': {
                                backgroundColor: '#c1c1c1',
                                borderRadius: 2,
                            },
                        }}
                    />
                </Box>
            </Modal>
        </div>
    );
}

// const ModalNext: React.FC<IModalProps<T>> = props => {
//     return <></>;
// };

// const ModalNext = <T,>(props: IModalProps<T>): React.ReactElement => {
//     return <></>;
// };

const enumInstances = {
    urgencyOptionsInstance: new ImplEnum.GenericEnum(ImplEnum.urgencyOptions),
    taskSituationOptionsInstance: new ImplEnum.GenericEnum(
        ImplEnum.taskSituationOptions,
    ),
    statusOptionsInstance: new ImplEnum.GenericEnum(ImplEnum.statusOptions),
    phaseLegalProcessOptionsInstance: new ImplEnum.GenericEnum(
        ImplEnum.phaseLegalProcessOptions,
    ),
    resultOptionsInstance: new ImplEnum.GenericEnum(ImplEnum.resultOptions),
    expertiseSituationOptionsInstance: new ImplEnum.GenericEnum(
        ImplEnum.expertiseSituationOptions,
    ),
};

const ModalNext = React.forwardRef(
    <T extends object>(
        props: IModalProps<T & IRowBase>,
        ref?: React.Ref<ImperativeHandleAccessedByMainContainerComponent>,
    ) => {
        const {
            open,
            setOpen,
            width,
            rows,
            setRows,
            keyLocalStorage,
            apiPath,
            route,
            columns,
            title,
        } = props;
        const history = useHistory();
        const { addToast } = useToast();
        const { setOpenLoading } = useContextGlobal();

        const [
            openModalInactiveNotification,
            setOpenModalInactiveNotification,
        ] = React.useState(false);
        const [idInactiveNotification, setIdInactiveNotification] =
            React.useState<string>('');

        const handleClose = React.useCallback(() => {
            setOpen(false);
        }, [setOpen]);

        const handleClick = React.useCallback(
            (id: string, row: any) => {
                // changeToView(row);
                handleClose();
                history.push(`${route}/${id}`);
            },
            [handleClose, history, route],
        );

        const changeToView = React.useCallback(
            (row: any) => {
                if (row?.original?.view) {
                    return;
                }

                if (!row?.original?.id) {
                    return;
                }

                api.patch(`${apiPath}/view/1`, {
                    ids: [row.original.id],
                })
                    .then(_ => {
                        changeRowsToView();
                    })
                    .catch(error => {
                        const messagesResponse =
                            handleExceptionMultipleMessages(error);
                        for (const messageResponse of messagesResponse) {
                            addToast({
                                type: 'error',
                                title: message.error.save,
                                description: messageResponse,
                            });
                        }
                    });
            },
            [addToast, apiPath],
        );

        const handleChecked = React.useMemo<boolean>(() => {
            const size = rows.filter((i: any) => i.finished)?.length || 0;
            return rows.length === size;
        }, [rows]);

        const styleModal = {
            ...style,
        };

        if (width <= 800) {
            styleModal.width = '90%';
        }

        const addStyleNotView = (row: any) => {
            return {
                ...(!row.original.view
                    ? {
                          fontWeight: 'bold',
                      }
                    : {}),
            };
        };

        const changeRowsToView = React.useCallback(() => {
            setTimeout(() => {
                let items: any = localStorage.getItem(keyLocalStorage);
                if (items) {
                    items = JSON.parse(items);
                }

                items = items.map((item: any) => ({ ...item, view: true }));
                localStorage.setItem(keyLocalStorage, JSON.stringify(items));
                setRows(items);
            }, 500);
        }, [keyLocalStorage, setRows]);

        const endDeadline = React.useCallback(
            async (data: any[]) => {
                const ids: string[] = [];
                const keep: any[] = [];
                data.forEach((r: any) => {
                    if (r.finished) {
                        ids.push(r.id);
                    } else {
                        keep.push(r);
                    }
                });

                if (ids.length === 0) {
                    addToast({
                        type: 'warn',
                        title: 'Nenhum registro selecionado.',
                        description: '',
                    });
                    return;
                }

                setOpenLoading(true);

                try {
                    await api.patch(`${apiPath}/enddeadline`, { ids });

                    addToast({
                        type: 'success',
                        title: message.success.save,
                        description: 'Prazos encerrados com sucesso',
                    });
                } catch (error) {
                    const { messageResponse, typeFeedback } = handleExceptionMessage(error);
                    addToast({
                        type: typeFeedback,
                        title: message.error.save,
                        description: messageResponse,
                    });
                } finally {
                    setOpenLoading(false);
                }
            },
            [addToast, apiPath, keyLocalStorage, setRows],
        );

        const handleInactiveNotification = async (id: string) => {
            setOpenLoading(true);
            try {
                await api.patch(`${apiPath}/enddeadline`, { ids: [id] });

                addToast({
                    type: 'success',
                    title: message.success.save,
                    description: 'Prazo encerrado com sucesso',
                });
            } catch (error: any) {
                const { messageResponse, typeFeedback } = handleExceptionMessage(error);
                addToast({
                    type: typeFeedback,
                    title: message.error.delete,
                    description: messageResponse,
                });
            } finally {
                setOpenLoading(false);
            }
        };

        const handleConfirmeInactiveNotification = async (confirm: boolean) => {
            if (confirm) {
                setOpenModalInactiveNotification(false);
                handleInactiveNotification(idInactiveNotification);
                setIdInactiveNotification('');
            } else {
                setOpenModalInactiveNotification(false);
                setIdInactiveNotification('');
            }
        };

        React.useImperativeHandle(
            ref,
            () => ({
                addStyleNotView,
                handleClick,
                setOpenModalInactiveNotification,
                setIdInactiveNotification,
                changeToView,
            }),
            [handleClick, changeToView],
        );

        return (
            <div>
                <AlertDialog
                    handleConfirmation={handleConfirmeInactiveNotification}
                    open={openModalInactiveNotification}
                    messageDialogTitle={
                        'Tem certeza que deseja encerrar o prazo/pendência?'
                    }
                />
                <Modal
                    open={open}
                    onClose={handleClose}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description">
                    <Box sx={styleModal} component={'div'}>
                        <div className="header-modal">
                            <Typography
                                id="modal-modal-title"
                                variant="h6"
                                component="h2">
                                {title}
                            </Typography>
                            <IconButton onClick={handleClose}>
                                <CloseIcon />
                            </IconButton>
                        </div>
                        <Grid sx={{ pt: 2, pb: 2 }} container spacing={2}>
                            <Grid item xs={12}>
                                <Typography
                                    sx={{
                                        flex: '1 1 100%',
                                        fontSize: '16px',
                                        pb: 1,
                                    }}
                                    variant="h6"
                                    id="tableTitle"
                                    component="div">
                                    <FormButton
                                        typeButton="custom"
                                        variant="contained"
                                        id={'endDeadline'}
                                        label={'Encerrar prazos/pendências'}
                                        onClick={() => endDeadline(rows)}
                                        icon={
                                            <IconComponent icon={icons.Check} />
                                        }
                                    />
                                </Typography>
                            </Grid>
                            <Grid item xs={12}>
                                Selecionar todas:{' '}
                                <Checkbox
                                    checked={handleChecked}
                                    onChange={event => {
                                        let rowsData = [...rows];
                                        rowsData.forEach((p: any) => {
                                            p.finished = event.target.checked;
                                            p.token =
                                                localStorage.getItem(
                                                    '@GESSIS:token',
                                                );
                                        });
                                        console.log(rowsData);
                                        localStorage.setItem(
                                            '@GESSIS:nextExpertise',
                                            JSON.stringify(rowsData),
                                        );

                                        setRows(rowsData);
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TableGeneric
                                    data={rows}
                                    columns={columns}
                                    minWidth={650}
                                    sxTableContainer={{
                                        height: width <= 800 ? 400 : 600,
                                        '&::-webkit-scrollbar': {
                                            width: 8,
                                        },
                                        '&::-webkit-scrollbar-track': {
                                            backgroundColor: '#f1f1f1',
                                            borderRadius: 2,
                                        },
                                        '&::-webkit-scrollbar-thumb': {
                                            backgroundColor: '#c1c1c1',
                                            borderRadius: 2,
                                        },
                                    }}
                                />
                            </Grid>
                        </Grid>
                    </Box>
                </Modal>
            </div>
        );
    },
);

function ModalAward({
    open,
    setOpen,
    rows,
    setListAwardedCustomers,
    width,
}: ModalAwardProps) {
    const [dataAwardCustomer, setDataAwardCustomer] = React.useState<
        AwardCustomer | undefined
    >(undefined);
    const [openModal, setOpenModal] = React.useState(false);

    const handleClose = () => {
        setOpen(false);
    };

    const handleClick = (
        event: React.MouseEvent<unknown>,
        data: AwardCustomer,
    ) => {
        setDataAwardCustomer(data);
        setOpenModal(true);
    };

    const styleModal = {
        ...style,
    };
    if (width <= 800) {
        styleModal.width = '90%';
    }

    return (
        <div>
            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description">
                <Box sx={styleModal} component={'div'}>
                    <div className="header-modal">
                        <Typography
                            id="modal-modal-title"
                            variant="h6"
                            component="h2">
                            {/* {titleMessages.awardedCustomers} */}
                        </Typography>
                        <IconButton onClick={handleClose}>
                            <CloseIcon />
                        </IconButton>
                    </div>
                    <ModalApplyAward
                        open={openModal}
                        setOpen={setOpenModal}
                        data={dataAwardCustomer}
                        setListAwardedCustomers={setListAwardedCustomers}
                        width={width}
                    />
                    <TableContainer
                        sx={{
                            height: width <= 800 ? 400 : 600,
                            '&::-webkit-scrollbar': {
                                width: 8,
                            },
                            '&::-webkit-scrollbar-track': {
                                backgroundColor: '#f1f1f1',
                                borderRadius: 2,
                            },
                            '&::-webkit-scrollbar-thumb': {
                                backgroundColor: '#c1c1c1',
                                borderRadius: 2,
                            },
                        }}>
                        <Table
                            // sx={{ minWidth: 750 }}
                            sx={{ height: 'max-content' }}
                            aria-labelledby="tableTitle"
                            size="small">
                            <TableHead>
                                <TableRow>
                                    {headCellsAward.map(headCell => (
                                        <TableCell
                                            key={headCell.id}
                                            align={
                                                headCell.numeric
                                                    ? 'right'
                                                    : 'left'
                                            }
                                            padding={
                                                headCell.disablePadding
                                                    ? 'none'
                                                    : 'normal'
                                            }>
                                            {headCell.label}
                                        </TableCell>
                                    ))}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {rows.map(row => {
                                    return (
                                        <TableRow key={row.id}>
                                            <TableCell
                                                scope="row"
                                                sx={{ cursor: 'pointer' }}
                                                onClick={event =>
                                                    handleClick(event, row)
                                                }>
                                                {row?.name}
                                            </TableCell>
                                            <TableCell
                                                align="left"
                                                scope="row"
                                                sx={{ cursor: 'pointer' }}
                                                onClick={event =>
                                                    handleClick(event, row)
                                                }>
                                                {formatNumber(row.total)}
                                            </TableCell>
                                            <TableCell
                                                scope="row"
                                                align="left"
                                                sx={{ cursor: 'pointer' }}
                                                onClick={event =>
                                                    handleClick(event, row)
                                                }>
                                                {formatNumber(row.awardGiven)}
                                            </TableCell>
                                            <TableCell
                                                align="left"
                                                sx={{ cursor: 'pointer' }}
                                                onClick={event =>
                                                    handleClick(event, row)
                                                }>
                                                {formatNumber(
                                                    row.total - row.awardGiven,
                                                )}
                                            </TableCell>
                                        </TableRow>
                                    );
                                })}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Box>
            </Modal>
        </div>
    );
}

function ModalApplyAward({
    open,
    setOpen,
    data,
    setListAwardedCustomers,
    width,
}: ModalApplyAwardProps) {
    const [focusAwardGiven, setFocusAwardGiven] = React.useState(true);

    const { addToast } = useToast();
    const { setOpenLoading } = useContextGlobal();

    const defaultValuesItems = {
        total: undefined,
        awardActual: undefined,
    };

    const rulesItems = {
        awardActual: {
            required: true,
        },
    };
    const styleModalApply = {
        ...style,
        width: '400px',
    };

    if (width <= 800) {
        styleModalApply.width = '88%';
    }

    const messageErrorItems = (errors: any, field: any) => {
        // awardGiven
        if (errors && errors.type === 'required' && field === 'awardActual') {
            return 'O campo valor atingido é obrigátorio.';
        }

        return '';
    };

    const useFormItems = useForm<AwardCustomer>({
        defaultValues: defaultValuesItems,
    });
    const controlItems = useFormItems.control;
    const setValueItems = useFormItems.setValue;
    const handleSubmit = useFormItems.handleSubmit;
    const reset = useFormItems.reset;

    React.useEffect(() => {
        setModel();
        setFocusAwardGiven(true);
    }, [open]);

    const setModel = () => {
        if (data) {
            setValueItems('total', data.total);
            setValueItems('awardActual', data.total - data?.awardGiven);
            setValueItems('id', data.id);
        }
    };

    const handleClose = () => {
        reset(defaultValuesItems);
        setOpen(false);
    };

    const submitItem = async (data: AwardCustomer) => {
        data.awardActual = floatValue(data.awardActual);
        data.total = floatValue(data.total);

        try {
            await api.patch(`customer/awardgiven/${data.id}`, data);
            addToast({
                type: 'success',
                title: message.success.save,
                description: '',
            });
            handleClose();

            let items: any = localStorage.getItem('@GESSIS:awardedCustomers');
            if (items) {
                items = JSON.parse(items);
            }

            items = items.filter((i: AwardCustomer) => i.id !== data.id);
            localStorage.setItem(
                '@GESSIS:awardedCustomers',
                JSON.stringify(items),
            );
            setListAwardedCustomers(items);
        } catch (error) {
            const { messageResponse, typeFeedback } = handleExceptionMessage(error);
            setOpenLoading(false);
            addToast({
                type: typeFeedback,
                title: message.error.save,
                description: messageResponse,
            });
        }
    };

    return (
        <div>
            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description">
                <Box sx={styleModalApply} component={'div'}>
                    <Typography
                        id="modal-modal-title"
                        variant="h6"
                        component="h2">
                        Salvar premiação
                    </Typography>
                    <form onSubmit={handleSubmit(data => submitItem(data))}>
                        <Grid sx={{ pt: 2, pb: 2 }} container spacing={2}>
                            <Grid item md={6} xs={12}>
                                <FormInputNumber
                                    name={`total`}
                                    control={controlItems}
                                    label="Acumulado total"
                                    decimalScale={2}
                                    readOnly={true}
                                />
                            </Grid>
                            <Grid item md={6} xs={12}>
                                <FormInputNumber
                                    name={`awardActual`}
                                    control={controlItems}
                                    rules={rulesItems.awardActual}
                                    label="Valor atingido"
                                    decimalScale={2}
                                    messageError={messageErrorItems}
                                    autoFocus={focusAwardGiven}
                                />
                            </Grid>
                        </Grid>
                        <span />
                        <Stack spacing={1} direction="row">
                            <FormButton
                                label={'Salvar'}
                                typeButton={'submit'}
                            />
                            <Button variant="outlined" onClick={handleClose}>
                                Cancelar
                            </Button>
                        </Stack>
                    </form>
                </Box>
            </Modal>
        </div>
    );
}

function ModalBirthDayCustomer({
    open,
    setOpen,
    rows,
    width,
    setRows,
}: ModalBirthdayCustomerProps) {
    const history = useHistory();
    const { addToast } = useToast();

    const handleClose = () => {
        setOpen(false);
    };

    const handleClick = (id: string, row: any) => {
        changeToView(row);
        history.push(`${paths.customerRegister}/${id}`);
    };

    const styleModal = {
        ...style,
    };

    if (width <= 800) {
        styleModal.width = '90%';
    }

    const listView = rows.filter((r: any) => !r.view).map(r => r.id);
    if (open && listView.length > 0) {
        api.patch(`notification/view/1`, {
            ids: [...listView],
        })
            .then(_ => {
                changeRowsToView();
            })
            .catch(error => {
                const messagesResponse = handleExceptionMultipleMessages(error);
                for (const messageResponse of messagesResponse) {
                    addToast({
                        type: 'error',
                        title: message.error.save,
                        description: messageResponse,
                    });
                }
            });
    }

    const addStyleNotView = (row: any) => {
        return {
            ...(!row.original.visited
                ? {
                      fontWeight: 'bold',
                  }
                : {}),
        };
    };

    const changeRowsToView = () => {
        let items: any = localStorage.getItem('@GESSIS:birthday');
        if (items) {
            items = JSON.parse(items);
        }

        items = items.map((item: any) => ({ ...item, view: true }));
        localStorage.setItem('@GESSIS:birthday', JSON.stringify(items));
        setRows(items);
    };

    const changeRowsToUpdate = (row: any) => {
        let items: any = localStorage.getItem('@GESSIS:birthday');
        if (items) {
            items = JSON.parse(items);
        }

        const indexList = items.findIndex((r: any) => r.id == row.original.id);
        if (indexList >= 0) {
            items[indexList].visited = true;
        }
        localStorage.setItem('@GESSIS:birthday', JSON.stringify(items));
        setRows(items);
    };

    const changeRowsToDelete = (row: any) => {
        let items: any = localStorage.getItem('@GESSIS:birthday');
        if (items) {
            items = JSON.parse(items);
        }

        items = items.filter((r: any) => r.id !== row.original.id);
        localStorage.setItem('@GESSIS:birthday', JSON.stringify(items));
        setRows(items);
    };

    function changeToView(row: any) {
        if (!row.visited) {
            api.patch(`notification/visited/1`, {
                ids: [row.original.id],
            })
                .then(_ => {
                    changeRowsToUpdate(row);
                })
                .catch(error => {
                    const messagesResponse =
                        handleExceptionMultipleMessages(error);
                    for (const messageResponse of messagesResponse) {
                        addToast({
                            type: 'error',
                            title: message.error.save,
                            description: messageResponse,
                        });
                    }
                });
        }
    }

    function deleteItem(row: any) {
        api.patch(`notification/active/0`, {
            ids: [row.original.id],
        })
            .then(_ => {
                changeRowsToDelete(row);
            })
            .catch(error => {
                const messagesResponse = handleExceptionMultipleMessages(error);
                for (const messageResponse of messagesResponse) {
                    addToast({
                        type: 'error',
                        title: message.error.delete,
                        description: messageResponse,
                    });
                }
            });
    }

    const columnsTable = React.useMemo<ColumnDef<Data>[]>(
        () => [
            {
                id: 'select',
                header: () => (
                    <TableCell align={'left'} padding={'normal'}>
                        Cliente
                    </TableCell>
                ),
                cell: ({ row }: any) => {
                    return (
                        <TableCell
                            sx={addStyleNotView(row)}
                            align="left"
                            key={row.id}
                            onClick={() =>
                                handleClick(row.original.body.id, row)
                            }>
                            {row.original?.body?.name}
                        </TableCell>
                    );
                },
            },
            {
                id: 'select',
                header: () => (
                    <TableCell align={'left'} padding={'normal'}>
                        Data de nascimento
                    </TableCell>
                ),
                cell: ({ row }: any) => {
                    return (
                        <TableCell
                            sx={addStyleNotView(row)}
                            align="left"
                            key={row.id}
                            onClick={() =>
                                handleClick(row.original.body.id, row)
                            }>
                            {formatDateWithoutHours(
                                row.original.body.birthDate,
                            )}
                        </TableCell>
                    );
                },
            },
            {
                id: 'select',
                header: () => (
                    <TableCell align={'left'} padding={'normal'}>
                        Idade
                    </TableCell>
                ),
                cell: ({ row }: any) => {
                    return (
                        <TableCell
                            sx={addStyleNotView(row)}
                            align="left"
                            key={row.id}
                            onClick={() =>
                                handleClick(row.original.body.id, row)
                            }>
                            {row.original?.body?.yearsOld}
                        </TableCell>
                    );
                },
            },
            {
                id: 'select',
                header: ({ table }: any) => <TableCell align="center" />,
                cell: ({ row }: any) => (
                    <TableCell align="right">
                        <Tooltip
                            title="Remover notificação"
                            onClick={() => {
                                deleteItem(row);
                            }}>
                            <IconButton>
                                <IconComponent icon={icons.Delete} />
                            </IconButton>
                        </Tooltip>
                    </TableCell>
                ),
            },
        ],
        [],
    );

    return (
        <div>
            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description">
                <Box sx={styleModal} component={'div'}>
                    <div className="header-modal">
                        <Typography
                            id="modal-modal-title"
                            variant="h6"
                            component="h2">
                            {titleMessages.birthDays}
                        </Typography>
                        <IconButton onClick={handleClose}>
                            <CloseIcon />
                        </IconButton>
                    </div>
                    <TableGeneric
                        data={rows}
                        columns={columnsTable}
                        minWidth={650}
                        sxTableContainer={{
                            height: width <= 800 ? 400 : 600,
                            '&::-webkit-scrollbar': {
                                width: 8,
                            },
                            '&::-webkit-scrollbar-track': {
                                backgroundColor: '#f1f1f1',
                                borderRadius: 2,
                            },
                            '&::-webkit-scrollbar-thumb': {
                                backgroundColor: '#c1c1c1',
                                borderRadius: 2,
                            },
                        }}
                    />
                </Box>
            </Modal>
        </div>
    );
}

function ModalOverdueInstallment({
    open,
    setOpen,
    rows,
    width,
}: ModalOverdueInstallmentProps) {
    const history = useHistory();

    const columns = React.useMemo<ColumnDef<IInvoiceDetail>[]>(
        () => [
            {
                id: 'select',
                header: () => (
                    <TableCell align={'left'} padding={'normal'}>
                        Código / Número
                    </TableCell>
                ),
                cell: ({ row }: any) => {
                    return (
                        <TableCell align="left" key={row.id}>
                            {row.original.outputProduct
                                ? row.original.outputProduct?.code
                                : row.original.workOrder?.code}
                        </TableCell>
                    );
                },
            },
            {
                accessorKey: 'description',
                cell: (cell: any) => (
                    <TableCell align="left">{cell?.getValue()}</TableCell>
                ),
                header: () => (
                    <TableCell align={'left'} padding={'normal'}>
                        Descrição
                    </TableCell>
                ),
            },
            {
                accessorKey: 'dueDate',
                cell: (cell: any) => (
                    <TableCell align="left">
                        {formatDateWithoutHours(cell?.getValue())}
                    </TableCell>
                ),
                header: () => (
                    <TableCell align={'left'} padding={'normal'}>
                        Data vencimento
                    </TableCell>
                ),
            },
            {
                id: 'select',
                header: (info: any) => {
                    return (
                        <TableCell align={'left'} padding={'normal'}>
                            Cliente
                        </TableCell>
                    );
                },
                cell: ({ row }: any) => {
                    return (
                        <TableCell align="left" key={row.id}>
                            {row.original.outputProduct
                                ? row.original.outputProduct?.customer?.name
                                : row.original.workOrder?.customer?.name}
                        </TableCell>
                    );
                },
            },
            {
                id: 'select',
                header: () => (
                    <TableCell align={'left'} padding={'normal'}>
                        Identificação
                    </TableCell>
                ),
                cell: ({ row }: any) => {
                    return (
                        <TableCell key={row.id} align="left">
                            {row.original.outputProduct
                                ? cpfAndCnpjMask(
                                      row.original.outputProduct?.customer
                                          ?.identification,
                                      false,
                                  )
                                : cpfAndCnpjMask(
                                      row.original.workOrder?.customer
                                          ?.identification,
                                      false,
                                  )}
                        </TableCell>
                    );
                },
            },
            {
                accessorKey: 'installmentValue',
                cell: (cell: any) => (
                    <TableCell align="left">
                        {formatNumber(cell?.getValue())}
                    </TableCell>
                ),
                header: () => (
                    <TableCell align={'left'} padding={'normal'}>
                        Valor
                    </TableCell>
                ),
            },
            {
                id: 'select',
                header: ({ table }: any) => <TableCell align="center" />,
                cell: ({ row }: any) => (
                    <TableCell align="right">
                        <Tooltip
                            title="Dar baixa"
                            onClick={() => {
                                const action = 'writeOff';

                                // Tirando action e invoiceId, é a query default da página
                                let limit = rowsPerPageOptions[0];
                                let currentPage = 1;
                                const queryVO = {
                                    limit,
                                    page: currentPage,
                                    downloaded: '0',
                                    dateInitial: momentZoneToUnix(
                                        momentZoneToDateAddDays({
                                            days: -90,
                                            startOfType: 'day',
                                        }),
                                    ),
                                    dateFinal: momentZoneToUnix(
                                        momentZoneToDateAddDays({
                                            days: 0,
                                            endOfType: 'day',
                                        }),
                                    ),
                                    action: action,
                                    invoiceId: row.original.id,
                                };

                                history.push(
                                    `/invoice-detail/payment?${objToQuery(
                                        queryVO,
                                    )}`,
                                );
                            }}>
                            <IconButton disabled={row.original.downloaded}>
                                <IconComponent icon={icons.DownloadDone} />
                            </IconButton>
                        </Tooltip>
                    </TableCell>
                ),
            },
        ],
        [],
    );

    const handleClose = () => {
        setOpen(false);
    };

    const styleModal = {
        ...style,
    };
    if (width <= 800) {
        styleModal.width = '90%';
    }

    return (
        <div>
            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description">
                <Box sx={styleModal} component={'div'}>
                    <div className="header-modal">
                        <Typography
                            id="modal-modal-title"
                            variant="h6"
                            component="h2">
                            {/* {titleMessages.overdueInstallments} */}
                        </Typography>
                        <IconButton onClick={handleClose}>
                            <CloseIcon />
                        </IconButton>
                    </div>
                    {/* <AlertDialog
                        handleConfirmation={handleConfirmAction}
                        open={openModalAction}
                        messageDialogTitle={messageDialogTitle}
                        handleCloseProps={handleCloseModalAction}
                        messageDetail={messageDialogContent}
                    /> */}
                    <TableGeneric
                        data={rows}
                        columns={columns}
                        minWidth={650}
                        sxTableContainer={{
                            height: width <= 800 ? 400 : 600,
                            '&::-webkit-scrollbar': {
                                width: 8,
                            },
                            '&::-webkit-scrollbar-track': {
                                backgroundColor: '#f1f1f1',
                                borderRadius: 2,
                            },
                            '&::-webkit-scrollbar-thumb': {
                                backgroundColor: '#c1c1c1',
                                borderRadius: 2,
                            },
                        }}
                    />
                </Box>
            </Modal>
        </div>
    );
}

const ITEM_HEIGHT = 48;

function LongMenu() {
    const history = useHistory();
    const { user, signOut } = useAuth();

    const handlePerfilUser = () => {
        handleClose();
        history.push(`${paths.userRegister}/${user.sub}`);
    };

    const options = [
        {
            title: 'Meu perfil',
            handleClick: handlePerfilUser,
            dataQa: 'menuItem-myPerfil',
        },
        {
            title: 'Sair',
            handleClick: signOut,
            dataQa: 'menuItem-logOut',
        },
    ];

    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleFirstName = (name: string) => {
        if (name) {
            const firstName = name.split(' ');
            return firstName[0];
        }
        return '';
    };

    return (
        <div>
            <IconButton
                aria-label="more"
                id="long-button"
                aria-controls={open ? 'long-menu' : undefined}
                aria-expanded={open ? 'true' : undefined}
                aria-haspopup="true"
                data-qa="iconButton-userName"
                onClick={handleClick}>
                <Typography
                    sx={{ flex: '1 1 100%', fontSize: '16px', color: '#fff' }}
                    variant="h6"
                    component="div">
                    {handleFirstName(user.name)}
                </Typography>
                <MoreVertIcon sx={{ color: '#fff' }} />
            </IconButton>
            <Menu
                id="long-menu"
                MenuListProps={{
                    'aria-labelledby': 'long-button',
                }}
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                PaperProps={{
                    style: {
                        maxHeight: ITEM_HEIGHT * 4.5,
                        width: '20ch',
                    },
                }}>
                {options.map(option => (
                    <MenuItem
                        key={option.title}
                        // selected={option === 'Pyxis'}
                        data-qa={option.dataQa}
                        onClick={option.handleClick}>
                        {option.title}
                    </MenuItem>
                ))}
            </Menu>
        </div>
    );
}

export default MainContainer;
